// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:02.820Z
// Property: Terminal 21 (ID: 6767906449166345)
// Collections: 45 amenities, 37 floorplans (live), 36 photos, 78 POIs, 2 reviews, 1 virtual tours, 6 office hours, 5 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166345",
  "property_external_id": "2926",
  "property_zillow_url": "https://www.zillow.com/apartments/pittsburgh-pa/terminal-21/CkBVjL/",
  "property_apartments_url": "https://www.apartments.com/terminal-21-pittsburgh-pa/eqe2jvp/",
  "property_google_business_url": "https://www.google.com/maps/place/Terminal+21+Apartments/data=!4m2!3m1!1s0x0:0xd113ed4d5837fda2?sa=X&ved=2ahUKEwjntu3r6LiSAxU5m2oFHfkaJ_gQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "55474708127",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "terminal-21",
  "property_name": "Terminal 21",
  "property_website_url": "https://www.liveterminal21.com/",
  "property_domain": "https://www.liveterminal21.com/",
  "property_address": "615 First Avenue",
  "property_full_address": "615 First Ave, Pittsburgh, PA 15219",
  "property_address_1": "615 First Ave",
  "property_address_2": null,
  "property_address_city": "Pittsburgh",
  "property_address_state": "PA",
  "property_address_zip_full": "15219",
  "property_address_zip": "15219",
  "property_address_country": "US",
  "property_address_county": "Allegheny County",
  "property_neighborhood_address": "Downtown",
  "property_address_latitude": "40.4356729",
  "property_address_longitude": "-79.99575670000002",
  "property_email": "terminal21@aionmanagement.com",
  "property_phone": "(412) 926-6776",
  "property_call_tracking_phone": "855-842-2584",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Terminal 21 in Pittsburgh, PA—where modern living meets vibrant community life. Choose from stylish studio, one, or two-bedroom floor plans, all nestled within an array of luxurious amenities like a pet-friendly dog park, a co-working lounge, and a relaxing speakeasy. Inquire about your new home today!",
  "property_long_description": "Welcome to Terminal 21, your premier apartment community located in the heart of Pittsburgh, PA. With a diverse selection of floor plans, including modern Studios, spacious One Bedrooms, and family-friendly Two Bedrooms, you’re sure to find the perfect place to call home. Explore our array of delightful amenities designed for your comfort and convenience. \n\nUnwind in our Co-Working Lounge or host meetings in the Conference Room. Enjoy leisurely afternoons in the Speakeasy Lounge or the Game Room, perfect for socializing or indulging in friendly competition. Our fitness enthusiasts will appreciate the state-of-the-art Fitness Center and serene Yoga Studio, while pet lovers can take advantage of our Dog Park and dedicated Pet Wash Station.\n\nAt Terminal 21, we prioritize your peace of mind. Our controlled access building features an on-site management team and 24-hour emergency maintenance, ensuring you always feel safe and supported. Additional conveniences include an Amazon Hub for package deliveries, flexible rent payments, and an Online Resident Portal, streamline your living experience.\n\nLocated just steps away from public transportation, Terminal 21 offers breathtaking city and river views from various floors, including a stunning 10th-floor option. Residents can also enjoy our sought-after amenities like the Coffee Bar, Billiards, and a beautiful Courtyard to relax in.\n\nDon’t miss out on this exceptional living opportunity! Find your new home today—browse our availability or schedule a tour to visit our dynamic community! Experience the best of urban living at Terminal 21, where lifestyle meets luxury.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d4ea5-446a-7407-8689-c4bfed2ee2a4.webp",
  "property_featured_image_media": {
    "alt_text": "Building exterior entrance and signage for Terminal 2 building.",
    "public_id": "019d4ea5-446a-7407-8689-c4bfed2ee2a4",
    "storage_key": "property/6767906449166345/019d4ea5-446a-7407-8689-c4bfed2ee2a4.webp",
    "width": 2048,
    "height": 1364
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166345/019fd962-184b-72bf-acec-0992e119532b.m4v",
  "property_featured_video_media": {
    "public_id": "019fd962-184b-72bf-acec-0992e119532b",
    "storage_key": "property/6767906449166345/019fd962-184b-72bf-acec-0992e119532b.m4v",
    "thumbnail_key": "property/6767906449166345/019fd962-184b-72bf-acec-0992e119532b_thumb.webp",
    "size_bytes": 21271569,
    "classification": "Community",
    "title": "Explore the Amenities and Spaces at Our Apartment Community",
    "description": "Discover the modern amenities, communal areas, and stylish living spaces available in our vibrant apartment community. Perfect for work, relaxation, and fitness."
  },
  "property_total_units": "205",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.09756097560975",
  "property_admin_fee": "200",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "2 pets per apartment, 100 lb weight limit, all animals must be housebroken, no breeding allowed.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350, and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://terminal21.loftliving.com/login",
  "property_apply_now_url": "https://www.liveterminal21.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026a-7f29-768e-9706-76421dfa846f.webp",
  "property_primary_logo_media": {
    "alt_text": "Terminal 21 logo",
    "public_id": "019d026a-7f29-768e-9706-76421dfa846f",
    "storage_key": "property/6767906449166345/019d026a-7f29-768e-9706-76421dfa846f.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026e-0a47-77d3-a4cc-b87045e25d04.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026e-0a47-77d3-a4cc-b87045e25d04",
    "storage_key": "property/6767906449166345/019d026e-0a47-77d3-a4cc-b87045e25d04.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026e-1d10-7698-b79f-005c38e71803.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Terminal 21 logo",
    "public_id": "019d026e-1d10-7698-b79f-005c38e71803",
    "storage_key": "property/6767906449166345/019d026e-1d10-7698-b79f-005c38e71803.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026e-2636-752a-b5f5-8f54da518f4c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Terminal 21 logo",
    "public_id": "019d026e-2636-752a-b5f5-8f54da518f4c",
    "storage_key": "property/6767906449166345/019d026e-2636-752a-b5f5-8f54da518f4c.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#0a434e",
  "property_secondary_color": "#55878d",
  "property_font_color": "#0a434e",
  "property_color_4": null,
  "property_color_3": "#d38872",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "404 - 1324",
  "property_sqft_min": "404",
  "property_sqft_max": "1324",
  "property_price_range": "1277 - 3011",
  "property_price_min": "1277",
  "property_price_max": "3011",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/Terminal21Living/",
  "property_instagram_url": "https://www.instagram.com/terminal21living/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmailnd3xNIgRov03WE3tE9E",
  "property_youtube_url": "https://www.youtube.com/@Terminal21Apartments",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=the-residences-at-the-historic-alcoa-building-pittsburgh",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Terminal 21",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "At Terminal 21 in Pittsburgh, PA, your lifestyle meets comfort. Choose from chic studios to spacious two-bedroom apartments, all with stunning city or river views. Enjoy our vibrant community, complete with a speakeasy lounge, fitness center, and pet-friendly spaces. Elevate your living experience today!",
  "property_home_floorplans_blurb": "At Terminal 21 in Pittsburgh, PA, your dream apartment awaits! From chic studios to spacious two-bedroom layouts, our thoughtfully designed floor plans cater to your lifestyle. Each home offers a unique blend of comfort and style. Browse our available apartment homes today and envision your next chapter!",
  "property_home_gallery_blurb": "At Terminal 21 in Pittsburgh, PA, immerse yourself in an exceptional lifestyle with versatile floor plans ranging from studios to two bedrooms. Enjoy contemporary amenities like a co-working lounge, fitness center, and stylish speakeasy. Whether you’re hosting in the game room or relaxing in the dog park, picture your ideal life here!",
  "property_home_neighborhood_blurb": "At Terminal 21 in Pittsburgh, your vibrant lifestyle begins with diverse floor plans—studio to two-bedroom apartments. Nestled near cultural gems like Heinz Hall and the Andy Warhol Museum, enjoy the ease of city living. Step outside to find parks, universities, and a thriving arts scene right at your doorstep.",
  "property_home_reviews_blurb": "At Terminal 21 in vibrant Pittsburgh, our apartments seamlessly blend industrial charm with modern living. With \"great layouts and fantastic social areas,\" our community embodies an energetic spirit. Experience the warmth of our dedicated staff and the convenience of city access. Dive into the artistic atmosphere that awaits you here!",
  "property_neighborhood_blurb": "At Terminal 21 in Pittsburgh, vibrant city life awaits just outside your door! Immerse yourself in a cultural hub, with the Andy Warhol Museum, Heinz Hall, and Point State Park nearby. Enjoy easy access to education at Point Park University and Carnegie Mellon University, making it the ideal community for urban explorers.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Elevate your lifestyle at Terminal 21 in Pittsburgh, PA, where urban convenience meets luxury living. Enjoy a vibrant community with amenities like a co-working lounge, a dog park, and a speakeasy lounge. Choose from expertly designed studio, one, or two-bedroom apartments tailored for your needs. Your perfect home awaits!",
  "property_applynow_blurb": "At Terminal 21 in Pittsburgh, PA, our stunning studio, one, and two-bedroom apartments offer modern living with stylish finishes and breathtaking views. Enjoy exclusive amenities like our speakeasy lounge, fitness center, and pet-friendly spaces. Elevate your lifestyle—secure your lease online today and embrace a vibrant community that fits you perfectly!",
  "property_contactus_blurb": "At Terminal 21 in vibrant Pittsburgh, PA, our diverse floor plans—from cozy studios to spacious two-bedroom apartments—cater to all lifestyles. Each home exudes chic comfort and modern design. Have questions? Contact our leasing team today, and let us help you find your perfect space in the heart of the city!",
  "property_faqs_blurb": "At Terminal 21 in Pittsburgh, PA, our diverse floor plans—studio, one-bedroom, and two-bedroom—cater to every lifestyle. Have questions? Our FAQs page is a treasure trove of insights, offering clarity on community features and amenities. Dive in to learn more about your future home!",
  "property_floorplans_blurb": "At Terminal 21 in the heart of Pittsburgh, PA, stylish living awaits. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that blend comfort with modern elegance. Each space invites you to experience urban life in a unique way. Browse our available apartment homes to find your perfect fit!",
  "property_gallery_blurb": "At Terminal 21 in Pittsburgh, each floor plan—from studios to two-bedroom apartments—offers vibrant living experiences. Engage in leisure at our speakeasy lounge or energize at the yoga studio. Picture yourself enjoying city or river views, surrounded by exceptional amenities like a dog park, co-working lounge, and more!",
  "property_interactivemap_blurb": "At Terminal 21 in vibrant Pittsburgh, PA, your ideal living space awaits, from studio retreats to spacious two-bedroom homes. Enjoy amenities like a dynamic co-working lounge, a chic speakeasy, and a serene yoga studio. Navigate your future home effortlessly with our interactive community map—your journey starts here!",
  "property_pets_blurb": "At Terminal 21 in Pittsburgh, your pets are part of the family. Our welcoming community allows up to two furry friends per apartment, ensuring a vibrant lifestyle that includes your beloved companions. Enjoy spacious living where both you and your pets can thrive—just remember to review our pet policy!",
  "property_referafriend_blurb": "At Terminal 21 in Pittsburgh, PA, our diverse floor plans range from cozy studios to spacious two-bedroom apartments, catering to your unique lifestyle. Great friends make great neighbors — refer a friend today and enjoy the vibrant community you both deserve! Join us in creating lasting connections!",
  "property_residentaccess_blurb": "Welcome to Terminal 21 in vibrant Pittsburgh, PA, where modern living meets comfort. Choose from stylish studio, one-bedroom, or spacious two-bedroom floor plans. Your resident portal is your key—log in to effortlessly pay rent, schedule maintenance, and access exclusive community updates. Elevate your lifestyle today!",
  "property_reviews_blurb": "At Terminal 21 in Pittsburgh, our residents rave about the \"cool artistic atmosphere\" and modern urban lofts designed with expansive windows that invite abundant natural light. With fantastic layouts and vibrant community spaces, it's a hub for connection and creativity. See what our residents have to say about living at our community!",
  "property_created_at": "1757011561105",
  "property_scheduletour_blurb": "At Terminal 21 in Pittsburgh, PA, we offer a range of thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom apartments tailored for your lifestyle. Schedule a tour to experience vibrant community living, and see what our residents love about calling Terminal 21 home! Your ideal space awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Terminal 21 in vibrant Pittsburgh, PA! Our diverse floor plans—including cozy studios, spacious one-bedroom, and welcoming two-bedroom apartments—offer the perfect fit for your lifestyle. Keep an eye on your inbox; a team member will connect with you soon to enhance your living experience!",
  "property_virtualtours_blurb": "At Terminal 21 in Pittsburgh, PA, our thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom—elevate urban living. Each apartment offers a unique blend of style and comfort. Enjoy the convenience and charm of our community. Ready to envision your future home? Take a virtual tour today!",
  "property_copyright": "2025 All Rights Reserved. Terminal 21",
  "property_seo_title_home": "Terminal 21 | Downtown Pittsburgh Apartments",
  "property_seo_description_home": "Elevate your lifestyle at Terminal 21 apartments in Pittsburgh with chic studios and spacious two-bedrooms, plus a fitness center and dog park!",
  "property_seo_title_floorplans": "Floor Plans | Apartments for Rent in Pittsburgh",
  "property_seo_description_floorplans": "Find your perfect home at Terminal 21 in Pittsburgh! Choose from stylish studio, one, or two-bedroom layouts that fit your lifestyle. Browse floor plans now!",
  "property_seo_title_amenities": "Amenities | Pittsburgh, PA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Terminal 21, Pittsburgh! Enjoy a speakeasy lounge, dog park, and top amenities that inspire community living.",
  "property_seo_title_gallery": "Gallery | Apartments in Pittsburgh, PA",
  "property_seo_description_gallery": "Capture your ideal lifestyle at Terminal 21 in Pittsburgh! From stunning views to vibrant amenities, envision your next chapter with us. Picture life elevated!",
  "property_seo_title_virtualtours": "Virtual Tours | Terminal 21 Apartments",
  "property_seo_description_virtualtours": "Experience life at Terminal 21 in Pittsburgh, PA! Take a virtual tour of our stylish studio, one, and two-bedroom apartments today and find your perfect home.",
  "property_seo_title_interactivemap": "Interactive Map | Terminal 21 Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at Terminal 21 in Pittsburgh! Use our interactive map to browse floor plans, amenities, and find your dream apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pittsburgh, PA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Terminal 21 in Pittsburgh, PA. Check out local favorites and hidden gems just steps from your front door!",
  "property_seo_title_contact": "Contact Us | Terminal 21",
  "property_seo_description_contact": "Connect with Terminal 21 in Pittsburgh, PA! Our leasing team is ready to help you find the perfect studio, one, or two-bedroom home. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Pittsburgh, PA",
  "property_seo_description_faqs": "Uncover answers to your burning questions at Terminal 21 in Pittsburgh. Learn about our amenities, floor plans, and more—your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pittsburgh, PA",
  "property_seo_description_reviews": "Experience life at Terminal 21 in Pittsburgh! Check out resident reviews to see why our community's amenities and vibrant atmosphere make us the perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Pittsburgh, PA",
  "property_seo_description_applynow": "Discover Terminal 21, the best apartments in Pittsburgh! Stylish studios and 1-2 bedroom apartments with great amenities. Enjoy convenience—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Terminal 21",
  "property_seo_description_residentaccess": "Unlock your Terminal 21 experience! Access your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Terminal 21",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Terminal 21 in Pittsburgh, PA, and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Terminal 21",
  "property_seo_description_scheduletour": "Experience urban living at Terminal 21 in Pittsburgh! Schedule a tour today and discover your future home in a vibrant community filled with modern amenities.",
  "property_seo_title_privacy": "Privacy Policy | Terminal 21",
  "property_seo_description_privacy": "Your privacy matters at Terminal 21. Learn how we safeguard your data while you enjoy life in Pittsburgh’s vibrant apartment community. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Terminal 21",
  "property_seo_description_accessibility": "Experience accessibility like never before at Terminal 21 in Pittsburgh, PA. We prioritize digital inclusion for all. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Terminal 21",
  "property_seo_description_sitemap": "Uncover the layout of Terminal 21 in Pittsburgh, PA. Navigate through our community offerings, amenities, and apartment options in one convenient place!",
  "property_seo_title_thankyou": "Thank You | Terminal 21",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Terminal 21 in Pittsburgh is valued. Our team will connect soon to guide you home to comfort and style.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293568787",
  "amenities": [
    {
      "id": "custom_5b460d24-7fc2-4c80-8e04-70f98c7e596b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_189b9cc7-0289-4796-ab99-94d403e704c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Arcade & Billiards",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b646f88-712b-4c01-9260-eec9e6184e02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Bike Storage & Repair Station",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4387d533-5c7a-440f-9e38-166accc3721d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfa31804-2e02-4a86-8687-2b60f706d8cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Conference Room (for resident use)",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e436538-c110-4b02-90d2-afa7b9b16bc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled-Access Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34b1fdd8-1cea-4e01-9e97-6c8088079e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b96dc20f-eba7-4f0d-8d69-c5510775e29d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Flex Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1997aae-2991-4248-89a1-319cbea7899c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9633e6f7-b982-4eef-a8f7-68767086664b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Room on each floor",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73ca3953-0f5c-417c-ab51-45d77b29fd7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Maker's Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51110718-2b51-4db3-be71-73ff38038633",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management and Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc25d9b4-e500-487c-90c4-e3cb401f5160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fa6628d-dacf-4dee-9e5d-2315be40d860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9dc78d41-f92b-4811-9d41-8298f0b9ba9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Podcast Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1286d75b-7cdd-49e9-8c12-35b6aea7fe96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffdc36ca-4b8b-424c-855d-db7eab0d7fee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Speakeasy Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f854688b-084f-4858-a64a-f5ab12191875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f1bd438-e99e-445f-8881-837825a294fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Work Pods",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7937ef13-c45e-480c-86dd-1fc8f79f66c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2feed21e-5389-4b78-86a2-b35afcbae9cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bed3008c-a24c-4482-b0b7-efd12a8353cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f704deb-d0d2-4e3c-bb45-973a6b3492b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Exposed Concrete Flooring",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a66f2000-cbc7-4974-8802-b2d5b18c4e14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer/Dryer Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc89682c-07d9-49e9-bb58-d94bf82935ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d1a002e-8624-4eab-9281-c444db7b150d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bae5c3b7-094f-4618-a3be-2c8043f07d89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Windows",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13b3bf0b-4f6f-4161-81c1-6ee7736137de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bcb517a-8f37-4fba-9b06-22ab809e80aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Recessed Lighting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eea3643c-cd47-4b8b-8a14-8a2476ccd7cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13ab10b1-4c4d-4fc9-850e-5ff032909836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7655da5-9b65-4873-aa56-3ecbda1bce3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Subway Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bce83670-42f2-40fa-95ce-9f4b20c1533d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Studio, 1 & 2 Bedroom Apartments",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64f508ce-1d70-4f21-a41b-33eab6b9b468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-in Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93bf836e-62e6-433f-b657-19e1818679f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "City & River Views",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee6c4b58-832c-490d-9949-fe499df0d109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Incredible Location in Downtown Pittsburgh",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7d34f1e-8ee1-46b6-a685-be4d00b0b2cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Steps From First Avenue Station & PRT Bus Routes",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96d5ef58-bee7-4faa-af03-3414bf4e4d92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "11' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8638509c-06b0-4392-89d4-e7e6d82db777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "93 Walk Score® & Close to Shopping, Dining & Entertainment",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1313e47a-da6c-4899-a8ff-3cd256127aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Hub Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11125c55-78bf-4e7c-afce-0ad2a92f54ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f6dc23f-f6d5-4473-ba05-2e196299499a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48b7ac29-2850-4eea-8409-dfe0e18912bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Caterer Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d98ed008-4069-4aa2-8567-19dc72b1fdfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_441e3b16-a482-4738-a0d3-cfeef65c0c22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Loft Style Apartments",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d197fa0d-8c00-4442-bbdf-a4dc11c31e5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-9568-703c-b7a6-c957b47bd167.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019fd959-9568-703c-b7a6-c957b47bd167",
        "storage_key": "property/6767906449166345/019fd959-9568-703c-b7a6-c957b47bd167.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Modern kitchen with dark cabinets, stainless steel appliances, and a wooden table beside a white countertop at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a wooden table beside a white countertop at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-200-edit-1920w.png"
    },
    {
      "id": "custom_c5ecf0fc-9f29-40bf-a913-10de6c072d78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-9595-77d5-a69c-d05af70acb54.webp",
      "image_media": {
        "alt_text": "Luxury apartment living room with a blue sectional sofa, gold coffee table, and large windows.",
        "public_id": "019fd959-9595-77d5-a69c-d05af70acb54",
        "storage_key": "property/6767906449166345/019fd959-9595-77d5-a69c-d05af70acb54.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright living room with a blue sectional sofa, yellow pillows, orange chair, and tall white columns at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-300-edit-1920w.png"
    },
    {
      "id": "custom_e1b10d6f-f686-4dd4-b30b-c86a9a42e219",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-94c4-77db-b86f-638d5e00574d.webp",
      "image_media": {
        "alt_text": "Living room with a large blue sectional sofa, gold coffee table, and industrial windows.",
        "public_id": "019fd959-94c4-77db-b86f-638d5e00574d",
        "storage_key": "property/6767906449166345/019fd959-94c4-77db-b86f-638d5e00574d.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Bright living room with blue sectional, patterned rug, concrete floors, and large windows near a TV console at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright living room with blue sectional, patterned rug, concrete floors, and large windows near a TV console at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615-First-Ave-Unit-705-S2307-100-edit-1920w.jpg"
    },
    {
      "id": "custom_c3857823-d07b-45c6-8494-5512f376613b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-9497-703b-9630-8083fc72245b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and white countertops.",
        "public_id": "019fd959-9497-703b-9630-8083fc72245b",
        "storage_key": "property/6767906449166345/019fd959-9497-703b-9630-8083fc72245b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, white countertops, and breakfast bar at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2824%29_28-07-26_20_54-1920w.jpg"
    },
    {
      "id": "custom_5ec12d46-6dd9-447c-933b-c8e590bbd4e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-a03d-7655-8b26-6af60658d460.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with stainless steel appliances and sectional sofa.",
        "public_id": "019fd959-a03d-7655-8b26-6af60658d460",
        "storage_key": "property/6767906449166345/019fd959-a03d-7655-8b26-6af60658d460.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright open loft living room with kitchen, gray sofa, stainless appliances, and high ceilings at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright open loft living room with kitchen, gray sofa, stainless appliances, and high ceilings at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2818%29_28-07-26_21_46-1920w.jpeg"
    },
    {
      "id": "custom_2e37e3a7-c43c-432b-a239-21ccfa7e6b4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-a08b-70aa-ac61-b416048960eb.webp",
      "image_media": {
        "alt_text": "Living area and kitchen in a modern apartment with large windows, stainless steel appliances, and island seating.",
        "public_id": "019fd959-a08b-70aa-ac61-b416048960eb",
        "storage_key": "property/6767906449166345/019fd959-a08b-70aa-ac61-b416048960eb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright open loft living room with sectional sofa, TV console, kitchen island, and large windows at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright open loft living room with sectional sofa, TV console, kitchen island, and large windows at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2817%29_29-07-26_09_25-1920w.jpeg"
    },
    {
      "id": "custom_3e75a270-4224-4eb0-9cb2-6281153b4ba7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-a08b-70aa-ac61-b0f33541c44d.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, framed art, and a large window with blinds.",
        "public_id": "019fd959-a08b-70aa-ac61-b0f33541c44d",
        "storage_key": "property/6767906449166345/019fd959-a08b-70aa-ac61-b0f33541c44d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright bedroom with a bed, nightstand lamp, framed art, and large windows with city view at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2825%29_28-07-26_21_54-1920w.jpeg"
    },
    {
      "id": "custom_6d182745-b5ee-4bf7-a9e6-ffc9807a79ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-a0a9-76bd-bf30-216d6c849555.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a small dining area.",
        "public_id": "019fd959-a0a9-76bd-bf30-216d6c849555",
        "storage_key": "property/6767906449166345/019fd959-a0a9-76bd-bf30-216d6c849555.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen with dark cabinets, white countertops, and a small dining table in a bright apartment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, white countertops, and a small dining table in a bright apartment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%283%29_28-07-26_21_10-staged-1920w.jpg"
    },
    {
      "id": "custom_8019ae9a-84c9-4e6e-99aa-81f8a047e5cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-ac31-70a8-a1eb-3cec0e8f1743.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sofa, coffee table, dining table, and city view.",
        "public_id": "019fd959-ac31-70a8-a1eb-3cec0e8f1743",
        "storage_key": "property/6767906449166345/019fd959-ac31-70a8-a1eb-3cec0e8f1743.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright living room with green sofa, large windows, woven rug, and wall art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2830%29_29-07-26_10_04-1920w.jpg"
    },
    {
      "id": "custom_c92889cd-587e-43c6-90c3-60a6d46d0954",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-af54-756d-bbdf-68d48232b5d3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large window overlooking city buildings, featuring a queen-size bed with light blue and green linens.",
        "public_id": "019fd959-af54-756d-bbdf-68d48232b5d3",
        "storage_key": "property/6767906449166345/019fd959-af54-756d-bbdf-68d48232b5d3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright bedroom with a bed, large window, and potted plant in a modern apartment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright bedroom with a bed, large window, and potted plant in a modern apartment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2826%29_28-07-26_21_55-1920w.jpeg"
    },
    {
      "id": "custom_78d26d9a-61ae-43b7-8196-025ca4881dbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-b019-7050-901d-1939998ed0ef.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, coffee table, and modern console table with artwork.",
        "public_id": "019fd959-b019-7050-901d-1939998ed0ef",
        "storage_key": "property/6767906449166345/019fd959-b019-7050-901d-1939998ed0ef.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright living room with gray sofa, round coffee table, large window, potted plant, and TV console at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, round coffee table, large window, potted plant, and TV console at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2816%29_29-07-26_09_50-1920w.jpg"
    },
    {
      "id": "custom_9b664728-9f17-42a1-820d-37ef12f7ff4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-b92a-77bb-b61b-a2f96eb483fe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white countertops, and stainless steel appliances.",
        "public_id": "019fd959-b92a-77bb-b61b-a2f96eb483fe",
        "storage_key": "property/6767906449166345/019fd959-b92a-77bb-b61b-a2f96eb483fe.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen with dark cabinets, stainless appliances, white countertops, and a hallway entrance at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, stainless appliances, white countertops, and a hallway entrance at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%2835%29_28-07-26_21_05-1920w.jpg"
    },
    {
      "id": "custom_a9b2d5d1-4728-4d48-b370-02a52b98b4d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-b9dc-7320-946c-02d3123f1fbd.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, dresser, and large window.",
        "public_id": "019fd959-b9dc-7320-946c-02d3123f1fbd",
        "storage_key": "property/6767906449166345/019fd959-b9dc-7320-946c-02d3123f1fbd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright studio apartment with black bed, wooden dresser, and large window blinds at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright studio apartment with black bed, wooden dresser, and large window blinds at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/Terminal_21_7.29.26_downtown-pittsburgh-apartments-1-web-or-mls-615_First_Ave_Unit_705-S2307-001_%289%29_29-07-26_09_27-1920w.jpeg"
    },
    {
      "id": "custom_77492072-5c4b-4076-9ab2-c7bd0144d983",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-ba9f-76ed-867f-e17b1ada8dfc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019fd959-ba9f-76ed-867f-e17b1ada8dfc",
        "storage_key": "property/6767906449166345/019fd959-ba9f-76ed-867f-e17b1ada8dfc.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a vanity, mirror, toilet, and curved shower/tub with a striped curtain.",
      "link": "false",
      "alt_text": "Bright apartment bathroom with vanity, mirror, toilet, and curved shower/tub with striped curtain at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/67afaa4ccc1c2114845dace64e3e02f7-1920w.webp"
    },
    {
      "id": "custom_60613bcd-e56c-4e12-b3b4-436effc0e4a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-bb2a-7710-9df7-3d2e4d6c986c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, toilet, and vanity.",
        "public_id": "019fd959-bb2a-7710-9df7-3d2e4d6c986c",
        "storage_key": "property/6767906449166345/019fd959-bb2a-7710-9df7-3d2e4d6c986c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright bathroom with white shower, toilet, and vanity beside a window at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Bright bathroom with white shower, toilet, and vanity beside a window at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2837%29-1920w.jpg"
    },
    {
      "id": "custom_2cb5654e-2ebd-43e3-8deb-b573029ca903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c3ad-740c-9b68-91199e7ee07c.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with dumbbells, weight benches, and a Smith machine, featuring colorful elephant graffiti and a desert landscape on the screen.",
        "public_id": "019fd959-c3ad-740c-9b68-91199e7ee07c",
        "storage_key": "property/6767906449166345/019fd959-c3ad-740c-9b68-91199e7ee07c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern gym interior with weight benches, dumbbells, mirrors, and colorful graffiti wall art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern gym interior with weight benches, dumbbells, mirrors, and colorful graffiti wall art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2859%29-1920w.jpg"
    },
    {
      "id": "custom_b6459928-bcfe-4132-ac8d-f0155e636629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c552-75cc-ade6-42e55c6fdfed.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weightlifting equipment, and colorful mural art.",
        "public_id": "019fd959-c552-75cc-ade6-42e55c6fdfed",
        "storage_key": "property/6767906449166345/019fd959-c552-75cc-ade6-42e55c6fdfed.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern gym with weight machines, benches, and colorful mural walls under bright industrial lighting at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2856%29-1920w.jpg"
    },
    {
      "id": "custom_73eb4b82-c95b-41e7-9594-45ec7a381482",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c7a1-7258-b9a5-48679a83658a.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, bikes, rowing machines, and a motivational mural of a lion.",
        "public_id": "019fd959-c7a1-7258-b9a5-48679a83658a",
        "storage_key": "property/6767906449166345/019fd959-c7a1-7258-b9a5-48679a83658a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern gym interior with weight benches, dumbbells, mirrors, and colorful graffiti wall art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern gym with treadmills, mural art wall, and bold text reading “We are made for amazing things” at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2858%29-1920w.jpg"
    },
    {
      "id": "custom_123ff421-22b3-402e-ab4a-7b065d57d587",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-c7d6-74ec-8a69-98ab0b53c169.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a fenced-in artificial turf area in the foreground.",
        "public_id": "019fd959-c7d6-74ec-8a69-98ab0b53c169",
        "storage_key": "property/6767906449166345/019fd959-c7d6-74ec-8a69-98ab0b53c169.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Fenced micropark for pets at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2841%29-1920w.jpg"
    },
    {
      "id": "custom_74f6d05b-dd9b-4452-bd52-dfaa08f6a828",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-d363-7739-9be2-5cd6a17d1584.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with artificial turf and a vertical garden wall.",
        "public_id": "019fd959-d363-7739-9be2-5cd6a17d1584",
        "storage_key": "property/6767906449166345/019fd959-d363-7739-9be2-5cd6a17d1584.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Fenced micropark for pets at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Fenced micropark for pets at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2839%29-1920w.jpg"
    },
    {
      "id": "custom_0efb0763-b01c-48a2-b027-56b240c79d75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-d31e-7232-a810-ee6e751761c3.webp",
      "image_media": {
        "alt_text": "A photo studio setup with a green screen, ring light, and chairs.",
        "public_id": "019fd959-d31e-7232-a810-ee6e751761c3",
        "storage_key": "property/6767906449166345/019fd959-d31e-7232-a810-ee6e751761c3.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Community podcast studio with green screen backdrop, two blue chairs, and lighting equipment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Community podcast studio with green screen backdrop, two blue chairs, and lighting equipment at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/b9d76e879ff9da68aef75405685f9c66-1920w.webp"
    },
    {
      "id": "custom_ee70cc9b-e2f7-41a2-8372-729e2a539ebf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-d4bf-74a5-a784-cfdab0135bae.webp",
      "image_media": {
        "alt_text": "Dance studio with barre, mirrors, and a TV screen.",
        "public_id": "019fd959-d4bf-74a5-a784-cfdab0135bae",
        "storage_key": "property/6767906449166345/019fd959-d4bf-74a5-a784-cfdab0135bae.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Empty modern yoga studio with hardwood floor, ballet barre, mirrors, and TV at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Empty modern yoga studio with hardwood floor, ballet barre, mirrors, and TV at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2854%29-1920w.jpg"
    },
    {
      "id": "custom_a1a2008c-7760-4d0c-87fb-25c49c0169cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-d6ad-748d-88f6-667cec4b33b5.webp",
      "image_media": {
        "alt_text": "Graffiti art studio with workbenches and spray paint cans.",
        "public_id": "019fd959-d6ad-748d-88f6-667cec4b33b5",
        "storage_key": "property/6767906449166345/019fd959-d6ad-748d-88f6-667cec4b33b5.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "A communal workshop space with art tables, stools, and industrial lighting in a modern basement setting.",
      "link": "false",
      "alt_text": "Industrial workshop area with large wooden tables, stools, and exposed pipes at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/6296bfc46dae3f932c726e317294ef63-1920w.png"
    },
    {
      "id": "custom_4f438e29-c98f-4b4d-b470-88a135585163",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-deed-70aa-9c77-fc3b8e39d4a0.webp",
      "image_media": {
        "alt_text": "Community lounge area with tables, chairs, and a bar with stools.",
        "public_id": "019fd959-deed-70aa-9c77-fc3b8e39d4a0",
        "storage_key": "property/6767906449166345/019fd959-deed-70aa-9c77-fc3b8e39d4a0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern bar and lounge with round tables, orange chairs, blue stools, and a mirrored counter under ceiling lights at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Modern bar and lounge with round tables, orange chairs, blue stools, and a mirrored counter under ceiling lights at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2848%29-1920w.jpg"
    },
    {
      "id": "custom_67723927-7729-4a67-bffb-a1375cae0cd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-e138-7088-b20a-5b17b186d7cf.webp",
      "image_media": {
        "alt_text": "Community game room with arcade games, vending machines, and seating.",
        "public_id": "019fd959-e138-7088-b20a-5b17b186d7cf",
        "storage_key": "property/6767906449166345/019fd959-e138-7088-b20a-5b17b186d7cf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Red lounge with arcade games, vending machines, and a gray couch under industrial lighting at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Red lounge with arcade games, vending machines, and a gray couch under industrial lighting at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2851%29-1920w.jpg"
    },
    {
      "id": "custom_c931941c-9a46-4a55-9322-ceee0d020580",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-e3fd-7290-9ccc-e07d5bfb2a81.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table and ping pong table.",
        "public_id": "019fd959-e3fd-7290-9ccc-e07d5bfb2a81",
        "storage_key": "property/6767906449166345/019fd959-e3fd-7290-9ccc-e07d5bfb2a81.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Recreation room with pool table, ping-pong table, and seating in an industrial-style resident lounge at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Recreation room with pool table, ping-pong table, and seating in an industrial-style resident lounge at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2849%29-1920w.jpg"
    },
    {
      "id": "custom_6886fecb-f564-4f73-a392-36019b613340",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-e407-742b-b562-4ceff5c66bab.webp",
      "image_media": {
        "alt_text": "Modern lounge area with large sectional sofa, coffee table, and entertainment center.",
        "public_id": "019fd959-e407-742b-b562-4ceff5c66bab",
        "storage_key": "property/6767906449166345/019fd959-e407-742b-b562-4ceff5c66bab.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern living room with orange walls, beige sectional sofa, coffee table, and abstract wall art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2844%29-1920w.jpg"
    },
    {
      "id": "custom_54d41d66-7e62-4b95-b449-70e4a41f4b53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-ea72-71d3-bf72-472d0a890cbe.webp",
      "image_media": {
        "alt_text": "Community lounge area with chess boards and seating.",
        "public_id": "019fd959-ea72-71d3-bf72-472d0a890cbe",
        "storage_key": "property/6767906449166345/019fd959-ea72-71d3-bf72-472d0a890cbe.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stylish lounge with blue and beige sofas, round table, red walls, patterned rug, and modern starburst light fixture at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link": "false",
      "alt_text": "Stylish lounge with blue and beige sofas, round table, red walls, patterned rug, and modern starburst light fixture at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/downtown-pittsburgh-apartments-1-web-or-mls-615+First+Ave+Unit+705-S2307-001+%2846%29-1920w.jpg"
    },
    {
      "id": "custom_8a204a17-98eb-49be-822a-0cb7c9e53b3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-ec2d-7109-9ea7-6f9b62fd125d.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a long white table, chairs, kitchen, and graffiti-style art.",
        "public_id": "019fd959-ec2d-7109-9ea7-6f9b62fd125d",
        "storage_key": "property/6767906449166345/019fd959-ec2d-7109-9ea7-6f9b62fd125d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Contemporary resident lounge with a long communal table, assorted seating, and a kitchenette area.",
      "link": "false",
      "alt_text": "Modern community lounge with a long white table, mixed seating, and a kitchenette at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/f077ac998e3c0bad79442992d5ecf148-1920w.jpg"
    },
    {
      "id": "custom_6616135a-b9eb-4cfd-9350-a39d65231bc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-ee8c-720a-8b5e-fff1501afe52.webp",
      "image_media": {
        "alt_text": "Lobby area with a bar, stools, and a wall decorated with various train-themed art and signs.",
        "public_id": "019fd959-ee8c-720a-8b5e-fff1501afe52",
        "storage_key": "property/6767906449166345/019fd959-ee8c-720a-8b5e-fff1501afe52.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Modern community lobby featuring a curved counter and eclectic wall art gallery.",
      "link": "false",
      "alt_text": "Lobby area with a curved wooden reception counter, five gray stools, and a wall filled with framed art at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/8aebeea14e65643861446cdfc127ef1e-1920w.webp"
    },
    {
      "id": "custom_c87c4142-bd53-4fcb-9e47-ee20f43f5b40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-eef6-7188-9f1f-7d0b0d79bb24.webp",
      "image_media": {
        "alt_text": "Modern communal workspace with a long conference table and seating.",
        "public_id": "019fd959-eef6-7188-9f1f-7d0b0d79bb24",
        "storage_key": "property/6767906449166345/019fd959-eef6-7188-9f1f-7d0b0d79bb24.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Open community lounge with a long wooden table, white chairs, lounge seating, and a colorful geometric mural at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/9a944ea9be7ae15272d672bc0eb2a6b6-1920w.webp"
    },
    {
      "id": "custom_bd7fcd76-1017-4117-bfd0-608f4024bccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-f640-73a4-a449-664d7d90abc1.webp",
      "image_media": {
        "alt_text": "Modern community lounge with sectional sofas, ottomans, and a communal table.",
        "public_id": "019fd959-f640-73a4-a449-664d7d90abc1",
        "storage_key": "property/6767906449166345/019fd959-f640-73a4-a449-664d7d90abc1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "A spacious, vibrant resident lounge with sectional seating, casual tables, and contemporary wall art.",
      "link": "false",
      "alt_text": "Colorful modern community lounge with curved gray sectional, round ottomans, and bright mural at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/7b90abd39422b29780113fe3522b7b5b-1920w.webp"
    },
    {
      "id": "custom_21e0a6d6-f4b9-4f48-80da-40bedf00e1b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-f7da-74ba-9d36-9f0c88ba4f56.webp",
      "image_media": {
        "alt_text": "Modern lounge area with teal curved banquette seating, yellow accent walls, and a small table.",
        "public_id": "019fd959-f7da-74ba-9d36-9f0c88ba4f56",
        "storage_key": "property/6767906449166345/019fd959-f7da-74ba-9d36-9f0c88ba4f56.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Bright, modern apartment amenity lounge with colorful booths and soft seating for relaxing or working.",
      "link": "false",
      "alt_text": "Colorful residential lounge with blue walls, yellow padded dividers, and a round table at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/5767906449162442/6767906449166345/0446b60720ef0a76bd0f6bc277b877de-1920w.jpg"
    },
    {
      "id": "custom_c4bfdf47-66cb-4acc-aa00-90222727ca9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-faad-720b-9999-f59fee6232ff.webp",
      "image_media": {
        "alt_text": "Modern lounge area with curved sofas and a conference room.",
        "public_id": "019fd959-faad-720b-9999-f59fee6232ff",
        "storage_key": "property/6767906449166345/019fd959-faad-720b-9999-f59fee6232ff.webp",
        "width": 1920,
        "height": 1202
      },
      "title": "Community",
      "description": "A stylish resident lounge with modular seating, teal walls, and a conference room for gatherings.",
      "link": "false",
      "alt_text": "Teal-walled lounge with curved gray sectional seating and a conference room doorway at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/8719e0ba4b99c0394f6c1421987d1e83-1920w.png"
    },
    {
      "id": "custom_19943aab-8f21-4e5d-8bbc-5b7a6fd22bcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-fc23-7230-8d79-beb8fcbad47b.webp",
      "image_media": {
        "alt_text": "Modern lobby area with colorful geometric wall art and T21 logo.",
        "public_id": "019fd959-fc23-7230-8d79-beb8fcbad47b",
        "storage_key": "property/6767906449166345/019fd959-fc23-7230-8d79-beb8fcbad47b.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Bright, art-filled community lounge in a multifamily property with geometric murals and open seating.",
      "link": "false",
      "alt_text": "Interior lobby with colorful mural walls, railing, and seating; a person seated in the background at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/76f583705a1b8b0a19a4aaa23fb43a35-1920w.png"
    },
    {
      "id": "custom_42761085-493c-4b06-884f-2159324e94ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd95a-03de-75f1-80eb-741b0db75cba.webp",
      "image_media": {
        "alt_text": "Terminal 21 building exterior with modern signage and landscaping",
        "public_id": "019fd95a-03de-75f1-80eb-741b0db75cba",
        "storage_key": "property/6767906449166345/019fd95a-03de-75f1-80eb-741b0db75cba.webp",
        "width": 1920,
        "height": 1203
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building with retail storefronts and landscaped landscaping along the entrance.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with a storefront labeled Terminal 21 and a landscaped walkway at Terminal 21, a premier apartment community in Downtown Pittsburgh, Pennsylvania.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/ee475c4a/dms3rep/multi/opt/80175eaf2e4a736a023d6ca32009cfc5-1920w.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a2bff53a-2ca0-4aa5-9b6a-98ff5321ea63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Alihan's Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "124 6th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Upscale, white-tablecloth Middle Eastern & Mediterranean eatery with a full roster of classics.",
      "poi_long_description": "Upscale, white-tablecloth Middle Eastern & Mediterranean eatery with a full roster of classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-228f-727a-9ec3-d8716d069a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-228f-727a-9ec3-d8716d069a63",
        "storage_key": "property/6767906449166345/019fd958-228f-727a-9ec3-d8716d069a63.webp",
        "width": 1071,
        "height": 1072
      },
      "poi_business_url": "http://www.alihanscuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2186695031900264573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alihans-mediterranean-cuisine",
      "poi_latitude": "40.4432423",
      "poi_longitude": "-80.0025689",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-888-0630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ws4DVbxNIgRfdiGwIuzWB4",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e554a56f-9346-4e54-97ed-35b61b13fd57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Gaucho Parrilla Argentina",
      "poi_type": "Restaurants",
      "poi_address": "146 6th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Cheery Argentinian haunt with patio seating preparing wood-fire-grilled meats, plus salads & sides.",
      "poi_long_description": "Cheery Argentinian haunt with patio seating preparing wood-fire-grilled meats, plus salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd957-e688-7357-aca1-aa80a4d4b20a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd957-e688-7357-aca1-aa80a4d4b20a",
        "storage_key": "property/6767906449166345/019fd957-e688-7357-aca1-aa80a4d4b20a.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://eatgaucho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088907354271053183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gaucho-parrilla-argentina",
      "poi_latitude": "40.4427824",
      "poi_longitude": "-80.0025062",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-709-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLGRefzNIgRf_UaVEuRZtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a35be7c-8e51-4c97-a936-4a4abc3bd841",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Meat & Potatoes",
      "poi_type": "Restaurants",
      "poi_address": "649 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Elevated American comfort food & craft cocktails in a sophisticated gastropub setting.",
      "poi_long_description": "Elevated American comfort food & craft cocktails in a sophisticated gastropub setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd957-e84d-764b-beca-a1cb7328a06f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd957-e84d-764b-beca-a1cb7328a06f",
        "storage_key": "property/6767906449166345/019fd957-e84d-764b-beca-a1cb7328a06f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://meatandpotatoespgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13304237197818148063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meat--potatoes",
      "poi_latitude": "40.4431503",
      "poi_longitude": "-80.0011895",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-325-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b0b5-764e-aed3-fdc1be2b12ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b0b5-764e-aed3-fdc1be2b12ff",
        "storage_key": "property/6767906449166345/019d026b-b0b5-764e-aed3-fdc1be2b12ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QL2R1bxNIgR3zR9Fz4lorg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6440e7b1-1064-4709-bade-3c7d4f63238c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Apollo Cafe",
      "poi_type": "Restaurants",
      "poi_address": "429 Forbes Ave #100, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Casual, long-running cafe for American breakfast & lunch items, with some Mediterranean options.",
      "poi_long_description": "Casual, long-running cafe for American breakfast & lunch items, with some Mediterranean options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd957-f825-7337-a4ee-a9f1b729a624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd957-f825-7337-a4ee-a9f1b729a624",
        "storage_key": "property/6767906449166345/019fd957-f825-7337-a4ee-a9f1b729a624.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.apollocafepittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1793726412959261009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apollo-cafe",
      "poi_latitude": "40.4391559",
      "poi_longitude": "-79.9980466",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-471-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b0b6-7300-8c4a-a46821cde96c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b0b6-7300-8c4a-a46821cde96c",
        "storage_key": "property/6767906449166345/019d026b-b0b6-7300-8c4a-a46821cde96c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJr9-tVFfxNIgRUSGsRKuY5Bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6174c455-4a0d-42b4-8723-334ed8412ae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Bluebird Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "221 Forbes Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Cozy eatery dishing up sandwiches, salads, soups and baked goods made from scratch, along with coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd957-fca5-712d-b3c0-736722a7aad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd957-fca5-712d-b3c0-736722a7aad8",
        "storage_key": "property/6767906449166345/019fd957-fca5-712d-b3c0-736722a7aad8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluebirdkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1620906772953831636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluebird-kitchen",
      "poi_latitude": "40.4405464",
      "poi_longitude": "-80.0017735",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-642-4414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2Jlv1bxNIgR1BjwPx-efhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40acf11b-906a-4ed3-9a15-04a0e062f7e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "La Gourmandine Downtown",
      "poi_type": "Restaurants",
      "poi_address": "308 Forbes Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "French breads, pastries & other baked goods are offered alongside coffee & tea in cheery surrounds.",
      "poi_long_description": "French breads, pastries & other baked goods are offered alongside coffee & tea in cheery surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-0208-7458-bb6c-0f6b26f55ab1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-0208-7458-bb6c-0f6b26f55ab1",
        "storage_key": "property/6767906449166345/019fd958-0208-7458-bb6c-0f6b26f55ab1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://lagourmandinebakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15748680301051047918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-gourmandine-downtown",
      "poi_latitude": "40.4398492",
      "poi_longitude": "-80.0004969",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-456-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwC811bxNIgR7u9WMUuNjto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a12ad6c-79e9-4eee-b273-de1a710ceedd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Primanti Bros. Restaurant and Bar",
      "poi_type": "Restaurants",
      "poi_address": "2 Market Square, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Long-running Pittsburgh-born chain known for its sandwiches piled high with coleslaw & french fries.",
      "poi_long_description": "Long-running Pittsburgh-born chain known for its sandwiches piled high with coleslaw & french fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-1217-73c6-9416-cce8ec0fed08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-1217-73c6-9416-cce8ec0fed08",
        "storage_key": "property/6767906449166345/019fd958-1217-73c6-9416-cce8ec0fed08.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://primantibros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=389919188078503351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primanti-bros-restaurant-and-bar",
      "poi_latitude": "40.4402676",
      "poi_longitude": "-80.0025857",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-261-1599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsW0CpVbxNIgRtyWHiG9FaQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18e163bb-b09b-4fba-8c3d-064db1e596dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Bakersfield Penn Ave",
      "poi_type": "Restaurants",
      "poi_address": "940 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Tacos & a few other Mexican dishes are delivered in an upbeat, margarita-fueled atmosphere.",
      "poi_long_description": "Tacos & a few other Mexican dishes are delivered in an upbeat, margarita-fueled atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-1290-7235-b839-c4debe321a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-1290-7235-b839-c4debe321a28",
        "storage_key": "property/6767906449166345/019fd958-1290-7235-b839-c4debe321a28.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bakersfieldtacos.com/?utm_source=GoogleBusinessProfile&utm_medium=Website&utm_campaign=MapLabs",
      "poi_directions_map_url": "https://maps.google.com/?cid=17876685248465678441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakersfield-penn-ave",
      "poi_latitude": "40.4440518",
      "poi_longitude": "-79.996629",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-586-5024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA8jyCVjxNIgRaTBDzIS-Fvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_abe16f5c-fcd6-4f17-8a20-2014aaf0cd54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Nicky's Thai Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "903 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Colorful Thai eatery known for crab rangoon, plus curries, rice & noodle dishes.",
      "poi_long_description": "Colorful Thai eatery known for crab rangoon, plus curries, rice & noodle dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-1f44-739a-8d45-879817b04781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-1f44-739a-8d45-879817b04781",
        "storage_key": "property/6767906449166345/019fd958-1f44-739a-8d45-879817b04781.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nickysthaikitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12022760767219533277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nickys-thai-kitchen",
      "poi_latitude": "40.4439139",
      "poi_longitude": "-79.9982139",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-471-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJue7G_FfxNIgR3YWf7Tdt2aY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30e575f9-bd79-41a7-af9c-436ffb615399",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Original Oyster House",
      "poi_type": "Restaurants",
      "poi_address": "20 Market Square, Pittsburgh, PA 15222, USA",
      "poi_short_description": "This old-school fish house & tavern (since 1870) offers fresh seafood platters & drinks.",
      "poi_long_description": "This old-school fish house & tavern (since 1870) offers fresh seafood platters & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-1ad7-763c-948d-c4b0ff702bb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-1ad7-763c-948d-c4b0ff702bb4",
        "storage_key": "property/6767906449166345/019fd958-1ad7-763c-948d-c4b0ff702bb4.webp",
        "width": 400,
        "height": 267
      },
      "poi_business_url": "http://originaloysterhousepittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=912601172294585315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "original-oyster-house",
      "poi_latitude": "40.44096",
      "poi_longitude": "-80.00201",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-566-7925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-VSlFbxNIgR40s5WO41qgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94f8afb5-ca01-461e-8420-ebfc055c219b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Arepittas",
      "poi_type": "Restaurants",
      "poi_address": "412-428 Cherry Way, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Straightforward eatery serving Venezuelan-style snacks & mains in unpretentious surroundings.",
      "poi_long_description": "Straightforward eatery serving Venezuelan-style snacks & mains in unpretentious surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-1b90-75de-86a3-5c5b883c6c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-1b90-75de-86a3-5c5b883c6c95",
        "storage_key": "property/6767906449166345/019fd958-1b90-75de-86a3-5c5b883c6c95.webp",
        "width": 1079,
        "height": 512
      },
      "poi_business_url": "https://www.arepittas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13995924686719880922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arepittas",
      "poi_latitude": "40.4388268",
      "poi_longitude": "-79.9985239",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-281-1213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6g-slDxNIgR2g4PV1mDO8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63d74264-a780-4666-8403-065b273ad1e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Proper Brick Oven & Tap Room",
      "poi_type": "Restaurants",
      "poi_address": "139 7th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Relaxed Italian eatery for locally sourced pasta dishes & oven-fired pizzas paired with tap beers.",
      "poi_long_description": "Relaxed Italian eatery for locally sourced pasta dishes & oven-fired pizzas paired with tap beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-3c85-701a-965f-f8a46db3e758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-3c85-701a-965f-f8a46db3e758",
        "storage_key": "property/6767906449166345/019fd958-3c85-701a-965f-f8a46db3e758.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://properpgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17639526166080677944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "proper-brick-oven--tap-room",
      "poi_latitude": "40.4435631",
      "poi_longitude": "-80.0002063",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-281-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwEwzVfxNIgROGhy_5YvzPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_729ed618-af7b-49a9-b80d-9f82a6281809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Genoa Pizza & Bar",
      "poi_type": "Restaurants",
      "poi_address": "111 Market St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Counter serve offering a large menu including subs, wings & pasta plus pizza by the slice or pie.",
      "poi_long_description": "Counter serve offering a large menu including subs, wings & pasta plus pizza by the slice or pie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-27ae-7506-9b16-e65ce9c115f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-27ae-7506-9b16-e65ce9c115f1",
        "storage_key": "property/6767906449166345/019fd958-27ae-7506-9b16-e65ce9c115f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.genoapizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7691004057216562128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genoa-pizza--bar",
      "poi_latitude": "40.438928",
      "poi_longitude": "-80.003948",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-281-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUPo71PxNIgR0DN7_HDvu2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4db8e47d-9378-44df-9de7-0c63d216a93e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "The Eagle - Pittsburgh",
      "poi_type": "Restaurants",
      "poi_address": "737 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Convivial eatery & beer hall dishing up Southern classics such as fried chicken & spoonbread.",
      "poi_long_description": "Convivial eatery & beer hall dishing up Southern classics such as fried chicken & spoonbread.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-2a12-728e-a163-d0df230b1f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-2a12-728e-a163-d0df230b1f25",
        "storage_key": "property/6767906449166345/019fd958-2a12-728e-a163-d0df230b1f25.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.eaglerestaurant.com/locations/?utm_source=GoogleBusinessProfile&utm_medium=Website&utm_campaign=MapLabs&utm_content=Pittsburgh",
      "poi_directions_map_url": "https://maps.google.com/?cid=3365306795409410511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-eagle---pittsburgh",
      "poi_latitude": "40.4437105",
      "poi_longitude": "-79.9997072",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-688-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-afb8-73fa-8bd9-b758e96bc7d0",
        "storage_key": "property/6767906449166345/019d026b-afb8-73fa-8bd9-b758e96bc7d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0VnWfTxNIgRzwmWRLP4sy4",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d944babd-9329-47eb-b423-617407ca470f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "5th Avenue Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1701 Fifth Ave, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Corned-beef deli featuring stacked sandwiches, plus salads and friendly service provided by the owner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-38bb-7613-a567-cc829f6dc8a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-38bb-7613-a567-cc829f6dc8a7",
        "storage_key": "property/6767906449166345/019fd958-38bb-7613-a567-cc829f6dc8a7.webp",
        "width": 1280,
        "height": 953
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1772126362679802934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5th-avenue-food-market",
      "poi_latitude": "40.4387105",
      "poi_longitude": "-79.9824529",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-391-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b0b1-76eb-917e-25bdf2584bab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b0b1-76eb-917e-25bdf2584bab",
        "storage_key": "property/6767906449166345/019d026b-b0b1-76eb-917e-25bdf2584bab.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwzzER2HxNIgRNnyiqInblxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58e6ae2e-e11d-41fb-bf5f-10e4ac7f56f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Robert Wholey & Co. Inc.",
      "poi_type": "Shopping & Retail",
      "poi_address": "1711 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Long-running store featuring seafood, poultry & meat products, plus produce & other grocery items.",
      "poi_long_description": "Long-running store featuring seafood, poultry & meat products, plus produce & other grocery items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-3e6e-711a-b337-388fb98e2738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-3e6e-711a-b337-388fb98e2738",
        "storage_key": "property/6767906449166345/019fd958-3e6e-711a-b337-388fb98e2738.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholey.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15323082450361577486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-wholey--co-inc",
      "poi_latitude": "40.4498924",
      "poi_longitude": "-79.98596649999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-946-5397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b0b1-76eb-917e-25bdf2584bab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b0b1-76eb-917e-25bdf2584bab",
        "storage_key": "property/6767906449166345/019d026b-b0b1-76eb-917e-25bdf2584bab.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP1gKhd3zNIgRDvDSrU2GptQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9468fee2-4eb2-41b9-8689-2ecc93820b6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Pennsylvania Macaroni Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "2010-2012 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Long-standing shop providing Italian groceries, including cheese & pasta, plus a deli counter.",
      "poi_long_description": "Long-standing shop providing Italian groceries, including cheese & pasta, plus a deli counter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-401c-74e8-b7e6-76bfd69a7554.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-401c-74e8-b7e6-76bfd69a7554",
        "storage_key": "property/6767906449166345/019fd958-401c-74e8-b7e6-76bfd69a7554.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pennmac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14770655317608757995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsylvania-macaroni-co",
      "poi_latitude": "40.4512775",
      "poi_longitude": "-79.9834735",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-227-1982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b531-72a1-aa52-2732a222dcb2",
        "storage_key": "property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q0m4tzzNIgR6_rNycDo-8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5299e49d-15b7-4e80-ab91-cec389ba6c84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Lotus Food Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "1649 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Well-stocked shop for groceries, baked goods, frozen dumplings and more, plus a tea shop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-43c0-7680-b6ad-953a9a7cd1db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-43c0-7680-b6ad-953a9a7cd1db",
        "storage_key": "property/6767906449166345/019fd958-43c0-7680-b6ad-953a9a7cd1db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lotusfoodonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16258101147210213798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lotus-food-company",
      "poi_latitude": "40.44970259999999",
      "poi_longitude": "-79.9862923",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-281-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b531-72a1-aa52-2732a222dcb2",
        "storage_key": "property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVURit3zNIgRpunVsdpgoOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a65098e8-8fb6-4529-a3ae-d099d96eb047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Sambok Korean Groceries",
      "poi_type": "Shopping & Retail",
      "poi_address": "1735 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Korean grocery store offering a variety of Asian foods, including their popular chicken on a stick.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-4e01-7760-8de0-5b97f9ab81e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-4e01-7760-8de0-5b97f9ab81e0",
        "storage_key": "property/6767906449166345/019fd958-4e01-7760-8de0-5b97f9ab81e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15081692147594804493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sambok-korean-groceries",
      "poi_latitude": "40.4504045",
      "poi_longitude": "-79.98519739999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-261-9377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b531-72a1-aa52-2732a222dcb2",
        "storage_key": "property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYD4nt3zNIgRDb0vHRrvTNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27b460ec-4bd3-4b9d-bf67-d097b1fbdf06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Stan's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1809 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-5403-7085-9356-f30d8e8cbe3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-5403-7085-9356-f30d8e8cbe3c",
        "storage_key": "property/6767906449166345/019fd958-5403-7085-9356-f30d8e8cbe3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=171084688912225516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stans-market",
      "poi_latitude": "40.4507487",
      "poi_longitude": "-79.98482589999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-434-4799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b531-72a1-aa52-2732a222dcb2",
        "storage_key": "property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1KoC93zNIgR7BQfPZ7QXwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a38d2d19-e21c-4ebd-9c6e-9584e3ecfbcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "482 Smithfield St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-4c4b-7718-9c56-e29799668f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-4c4b-7718-9c56-e29799668f5e",
        "storage_key": "property/6767906449166345/019fd958-4c4b-7718-9c56-e29799668f5e.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pittsburgh-pa-pharmacies/482-smithfield-st-pittsburgh-pa-15219/storeid=17825?WT.mc_id=LS_GOOGLE_RX_17825",
      "poi_directions_map_url": "https://maps.google.com/?cid=16078241870447925717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.439803",
      "poi_longitude": "-79.998569",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-222-7298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53d-758d-8841-cd3b93f5e2a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53d-758d-8841-cd3b93f5e2a7",
        "storage_key": "property/6767906449166345/019d026b-b53d-758d-8841-cd3b93f5e2a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiyNG-TTxNIgR1VnchMtjId8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e7939362-5ac3-422d-8a05-375e323c6e13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-4de1-7155-b728-cde0e7b16662.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-4de1-7155-b728-cde0e7b16662",
        "storage_key": "property/6767906449166345/019fd958-4de1-7155-b728-cde0e7b16662.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/pittsburgh/601-penn-ave-36143?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15032410112698350855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.4429331",
      "poi_longitude": "-80.00203499999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-471-2658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b52e-747e-b076-72b4f3f450b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b52e-747e-b076-72b4f3f450b6",
        "storage_key": "property/6767906449166345/019d026b-b52e-747e-b076-72b4f3f450b6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJLbIBAdDtNIgRB_1fNVrZndA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9292ea2c-1adf-4f2d-a56d-7c90fe1fed89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Giant Eagle Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "318-320 Cedar Ave, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Supermarket with a pharmacy featuring organic and local products plus a salad bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-6005-71c8-bb77-37f90e714f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-6005-71c8-bb77-37f90e714f0f",
        "storage_key": "property/6767906449166345/019fd958-6005-71c8-bb77-37f90e714f0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gianteagle.com/stores/pa/titusville/titusville-giant-eagle/88?utm_source=google&utm_medium=organic&utm_campaign=ge_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=11773499832073482965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant-eagle-supermarket",
      "poi_latitude": "40.4514625",
      "poi_longitude": "-79.99960930000002",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-321-3551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b531-72a1-aa52-2732a222dcb2",
        "storage_key": "property/6767906449166345/019d026b-b531-72a1-aa52-2732a222dcb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe96CpPvzNIgR1XLc9bffY6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_045f5d46-270a-4220-b097-dc6aa8229c89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "The O'Brien Family Center + Back-Up Care",
      "poi_type": "Education",
      "poi_address": "500 First Ave, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-570b-752d-879c-2e501eb5a712.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-570b-752d-879c-2e501eb5a712",
        "storage_key": "property/6767906449166345/019fd958-570b-752d-879c-2e501eb5a712.webp",
        "width": 431,
        "height": 287
      },
      "poi_business_url": "https://backupcenters.brighthorizons.com/PA/Pittsburgh/obrien",
      "poi_directions_map_url": "https://maps.google.com/?cid=2958370227179158207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-obrien-family-center--back-up-care",
      "poi_latitude": "40.4357283",
      "poi_longitude": "-79.99820319999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-242-2737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8QgrusvxNIgRv_oaKQw-Dik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d571a9f3-36c7-45b5-9b59-79a2d55fcf88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Downtown Pittsburgh KinderCare",
      "poi_type": "Education",
      "poi_address": "600 Grant St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-572c-72a4-944d-c3533fe59398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-572c-72a4-944d-c3533fe59398",
        "storage_key": "property/6767906449166345/019fd958-572c-72a4-944d-c3533fe59398.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/pittsburgh/pa/073097?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MTI0LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264329068214636718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-pittsburgh-kindercare",
      "poi_latitude": "40.4414139",
      "poi_longitude": "-79.99470819999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-765-3973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT6B1U1jxNIgRrlBu706mM6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83cd168a-3d14-49c8-812f-0dfc8e4a0237",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "The Goddard School of Pittsburgh (Downtown)",
      "poi_type": "Education",
      "poi_address": "301 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Chain school for infants to kindergartners featuring rock-climbing walls, gymnasiums, and a curriculum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-5c8c-72b8-ac96-0df559cc8b0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-5c8c-72b8-ac96-0df559cc8b0f",
        "storage_key": "property/6767906449166345/019fd958-5c8c-72b8-ac96-0df559cc8b0f.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/pa/pittsburgh/pittsburgh-downtown?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=17081739274971652502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-pittsburgh-downtown",
      "poi_latitude": "40.4409125",
      "poi_longitude": "-79.9995977",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-515-1997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6cB2GlfxNIgRliGGHl6HDu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_92523af0-2fdf-4a0a-8005-66d739dad8ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Point Park University",
      "poi_type": "Education",
      "poi_address": "201 Wood St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-70b9-75b3-ba60-639b7e8179c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-70b9-75b3-ba60-639b7e8179c4",
        "storage_key": "property/6767906449166345/019fd958-70b9-75b3-ba60-639b7e8179c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pointpark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793739138826593381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-park-university",
      "poi_latitude": "40.4384916",
      "poi_longitude": "-80.0017987",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-391-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx2ZxR1HxNIgRZWSZeNtZ6oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_82903683-90fb-420e-8b29-cd3820e76bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Duquesne University",
      "poi_type": "Education",
      "poi_address": "600 Forbes Ave, Pittsburgh, PA 15282, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-6223-719a-bedd-317081223bc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-6223-719a-bedd-317081223bc0",
        "storage_key": "property/6767906449166345/019fd958-6223-719a-bedd-317081223bc0.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.duq.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14522005983332821861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duquesne-university",
      "poi_latitude": "40.4369485",
      "poi_longitude": "-79.99025759999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-396-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3PD-1vxNIgRZWumPoCHiMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66255898-eb05-4cf5-b014-36929d5003ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Carnegie Mellon University",
      "poi_type": "Education",
      "poi_address": "5000 Forbes Ave, Pittsburgh, PA 15213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-7cf6-701f-800d-837853089634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-7cf6-701f-800d-837853089634",
        "storage_key": "property/6767906449166345/019fd958-7cf6-701f-800d-837853089634.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cmu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9831757410451380980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carnegie-mellon-university",
      "poi_latitude": "40.4432027",
      "poi_longitude": "-79.9428499",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-268-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5pnWB_yNIgR9NrEH0ZrcYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_98e643b7-9ac4-4a6a-9d0b-8f698bd9f6e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Pittsburgh CAPA",
      "poi_type": "Education",
      "poi_address": "111 9th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-7723-712c-988f-ebcfcb8c4fc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-7723-712c-988f-ebcfcb8c4fc8",
        "storage_key": "property/6767906449166345/019fd958-7723-712c-988f-ebcfcb8c4fc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverpps.org/capa",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471207182474451501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-capa",
      "poi_latitude": "40.44475569999999",
      "poi_longitude": "-79.9986905",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-529-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_fWQv3zNIgRLZpADap7leQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff99841d-a247-41f8-b927-05abef7a5f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Milliones School",
      "poi_type": "Education",
      "poi_address": "3117 Centre Ave, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pghschools.org/milliones",
      "poi_directions_map_url": "https://maps.google.com/?cid=4354882287159193702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milliones-school",
      "poi_latitude": "40.4490213",
      "poi_longitude": "-79.9617329",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-529-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6w7iAy3yNIgRZrDD9F2mbzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_19017370-64f0-46b4-b17c-63594db77a74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Heinz Hall for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "600 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Circa-1927 home of the Pittsburgh Symphony Orchestra is a grand space for concerts & musicals.",
      "poi_long_description": "Circa-1927 home of the Pittsburgh Symphony Orchestra is a grand space for concerts & musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-7861-7577-b947-d3d06479e870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-7861-7577-b947-d3d06479e870",
        "storage_key": "property/6767906449166345/019fd958-7861-7577-b947-d3d06479e870.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.pittsburghsymphony.org/pso_home/web/heinz-hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6864795943914981527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heinz-hall-for-the-performing-arts",
      "poi_latitude": "40.4425691",
      "poi_longitude": "-80.00196799999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-392-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSd-GQlbxNIgRl0iYLIqnRF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6d8bf04e-c32e-4719-b88f-2deab595b894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Benedum Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "237 7th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "2,800-seat venue hosting local ballet, theater & opera companies, plus touring shows & musicians.",
      "poi_long_description": "2,800-seat venue hosting local ballet, theater & opera companies, plus touring shows & musicians.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-7b76-717c-8156-0e237161c1a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-7b76-717c-8156-0e237161c1a0",
        "storage_key": "property/6767906449166345/019fd958-7b76-717c-8156-0e237161c1a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://trustarts.org/pct_home/visit/facilities/benedum",
      "poi_directions_map_url": "https://maps.google.com/?cid=8335552743327879631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benedum-center-for-the-performing-arts",
      "poi_latitude": "40.4429853",
      "poi_longitude": "-80.000016",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-456-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQL8tVfxNIgRz1GXcA7VrXM",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_679f0597-8431-4274-87d4-d2e62954029a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Byham Theater",
      "poi_type": "Entertainment",
      "poi_address": "101 6th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Historic 1,300-seat theater featuring dance, theater & music performances.",
      "poi_long_description": "Historic 1,300-seat theater featuring dance, theater & music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-8380-735c-a70a-7520aafadbf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-8380-735c-a70a-7520aafadbf8",
        "storage_key": "property/6767906449166345/019fd958-8380-735c-a70a-7520aafadbf8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://trustarts.org/pct_home/visit/facilities/byham",
      "poi_directions_map_url": "https://maps.google.com/?cid=15891742811733894133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byham-theater",
      "poi_latitude": "40.4437911",
      "poi_longitude": "-80.00247490000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnw9tGFbxNIgR9SNEo-PPitw",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1cd8012-e87a-4c16-81d9-20ac21f19c58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "O'Reilly Theater",
      "poi_type": "Entertainment",
      "poi_address": "621 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Intimate public theater with 650 seats staging live performances including dramas & musicals.",
      "poi_long_description": "Intimate public theater with 650 seats staging live performances including dramas & musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-90eb-7678-b84f-1c6116ee3d1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-90eb-7678-b84f-1c6116ee3d1a",
        "storage_key": "property/6767906449166345/019fd958-90eb-7678-b84f-1c6116ee3d1a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ppt.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1780675535698388864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oreilly-theater",
      "poi_latitude": "40.4431144",
      "poi_longitude": "-80.0014915",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-316-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dsYR1bxNIgRgOeHHfc6thg",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b788d00-4e80-4be5-b807-5050db82bb67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "PPG Paints Arena",
      "poi_type": "Entertainment",
      "poi_address": "1001 Fifth Ave, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Arena hosts Penguins ice hockey & college basketball games &, plus major live music acts & events.",
      "poi_long_description": "Arena hosts Penguins ice hockey & college basketball games &, plus major live music acts & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-96ae-761d-acd3-7c3aa649cf61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-96ae-761d-acd3-7c3aa649cf61",
        "storage_key": "property/6767906449166345/019fd958-96ae-761d-acd3-7c3aa649cf61.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.ppgpaintsarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2025247486958487038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppg-paints-arena",
      "poi_latitude": "40.4393097",
      "poi_longitude": "-79.98955289999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-642-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqjl7xNIgR_sVp8tsfGxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0dde43df-1e26-4b0f-b5ef-36a7a1007173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Stage AE",
      "poi_type": "Entertainment",
      "poi_address": "400 N Shore Dr, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Rock concert venue with a vast interior space & balcony also has outdoor seating  & an indoor club.",
      "poi_long_description": "Rock concert venue with a vast interior space & balcony also has outdoor seating  & an indoor club.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-9140-74b7-9993-1e3cdc99e45f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-9140-74b7-9993-1e3cdc99e45f",
        "storage_key": "property/6767906449166345/019fd958-9140-74b7-9993-1e3cdc99e45f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stageae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895307685488619309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stage-ae",
      "poi_latitude": "40.4461361",
      "poi_longitude": "-80.0122828",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-229-5483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydWFLQD0NIgRLe9Z6TV7cns",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cafde57c-f0d7-44e1-98d1-5e82f1f8ef3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "The Andy Warhol Museum",
      "poi_type": "Entertainment",
      "poi_address": "117 Sandusky St, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Museum where Warhol's art is the star & the inspiration for new works, performances & lectures.",
      "poi_long_description": "Museum where Warhol's art is the star & the inspiration for new works, performances & lectures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a075-7463-a192-bb5e7501b2bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a075-7463-a192-bb5e7501b2bf",
        "storage_key": "property/6767906449166345/019fd958-a075-7463-a192-bb5e7501b2bf.webp",
        "width": 1110,
        "height": 1280
      },
      "poi_business_url": "https://www.warhol.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14628228251209049136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-andy-warhol-museum",
      "poi_latitude": "40.4483755",
      "poi_longitude": "-80.0024907",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-237-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbb6-7370-92ef-ad53e6650efc",
        "storage_key": "property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqofxNIgRMCSmPhfoAcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a950b264-f486-4f61-a7d0-aef7413b737a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Kamin Science Center",
      "poi_type": "Entertainment",
      "poi_address": "1 Allegheny Ave, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Museum & research center offers science-related exhibits, a planetarium, live shows & kids programs.",
      "poi_long_description": "Museum & research center offers science-related exhibits, a planetarium, live shows & kids programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a450-70a5-bc5d-41cf66040039.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a450-70a5-bc5d-41cf66040039",
        "storage_key": "property/6767906449166345/019fd958-a450-70a5-bc5d-41cf66040039.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kaminsciencecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15799696986910244856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kamin-science-center",
      "poi_latitude": "40.4456828",
      "poi_longitude": "-80.01818519999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-237-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbb6-7370-92ef-ad53e6650efc",
        "storage_key": "property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqofxNIgR-D-Y_7LMQ9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9779722b-e893-4cd1-9bdd-5dacdbf19d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Children's Museum of Pittsburgh",
      "poi_type": "Entertainment",
      "poi_address": "10 Children's Way, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Children's museum for hands-on learning offers play areas, educational exhibits & puppet shows.",
      "poi_long_description": "Children's museum for hands-on learning offers play areas, educational exhibits & puppet shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-9c69-763a-a16b-964cd8462e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-9c69-763a-a16b-964cd8462e31",
        "storage_key": "property/6767906449166345/019fd958-9c69-763a-a16b-964cd8462e31.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.pittsburghkids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14562065122464082294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-pittsburgh",
      "poi_latitude": "40.4528353",
      "poi_longitude": "-80.0064158",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-322-5058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbb6-7370-92ef-ad53e6650efc",
        "storage_key": "property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSw4X_jzNIgRdqmTZBPZFso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5f0417ba-5844-4d26-9281-1151455835de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Senator John Heinz History Center",
      "poi_type": "Entertainment",
      "poi_address": "1212 Smallman St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Smithsonian affiliate has 6 floors of historical exhibits, archives & a separate sports museum.",
      "poi_long_description": "Smithsonian affiliate has 6 floors of historical exhibits, archives & a separate sports museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a1d3-7136-8acf-49f99c4b4233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a1d3-7136-8acf-49f99c4b4233",
        "storage_key": "property/6767906449166345/019fd958-a1d3-7136-8acf-49f99c4b4233.webp",
        "width": 1200,
        "height": 750
      },
      "poi_business_url": "http://www.heinzhistorycenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5087244111269421195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "senator-john-heinz-history-center",
      "poi_latitude": "40.4468415",
      "poi_longitude": "-79.9920696",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-454-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbb6-7370-92ef-ad53e6650efc",
        "storage_key": "property/6767906449166345/019d026b-bbb6-7370-92ef-ad53e6650efc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7aBzePzNIgRi2Dp2ZCFmUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b940964d-f612-4888-8c88-a0ac7144c85a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "UPMC Mercy",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 Locust St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a63f-7018-bd5e-d9f842ec6179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a63f-7018-bd5e-d9f842ec6179",
        "storage_key": "property/6767906449166345/019fd958-a63f-7018-bd5e-d9f842ec6179.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.upmc.com/locations/hospitals/mercy?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-swpa-upmc-mercy",
      "poi_directions_map_url": "https://maps.google.com/?cid=8244303519153733630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-mercy",
      "poi_latitude": "40.4364439",
      "poi_longitude": "-79.985575",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-232-8111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbdd-75bd-86c8-b59998843069.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbdd-75bd-86c8-b59998843069",
        "storage_key": "property/6767906449166345/019d026b-bbdd-75bd-86c8-b59998843069.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsesVYGfxNIgR_j-p116maXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02d00e9f-4d7e-4edf-94af-132ded6ef6eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "AHN Express Care Services",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Penn Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a91b-72fb-849a-44f71bf04a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a91b-72fb-849a-44f71bf04a88",
        "storage_key": "property/6767906449166345/019fd958-a91b-72fb-849a-44f71bf04a88.webp",
        "width": 698,
        "height": 698
      },
      "poi_business_url": "https://www.ahn.org/locations/downtown-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16104574797048675222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahn-express-care-services",
      "poi_latitude": "40.4425449",
      "poi_longitude": "-80.003513",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-442-2343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66IbJqTxNIgRlnvLxHPxft8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5741dc60-563b-4aa6-baf9-b580fa51a134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "242-250 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-b344-77a0-a8f2-968e1251ac32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-b344-77a0-a8f2-968e1251ac32",
        "storage_key": "property/6767906449166345/019fd958-b344-77a0-a8f2-968e1251ac32.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pittsburgh-pa-pharmacies/242-250-fifth-ave-pittsburgh-pa-15222/storeid=4008?WT.mc_id=LS_GOOGLE_FS_4008",
      "poi_directions_map_url": "https://maps.google.com/?cid=17395180846759241227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.4407114",
      "poi_longitude": "-80.0010683",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-566-2619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1je5VbxNIgRC2bDBtEYaPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca423568-57fc-4d75-988b-ec9997c07686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "aither yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "339 Forbes Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-b58f-7762-bfd0-32cf2a26ccaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-b58f-7762-bfd0-32cf2a26ccaf",
        "storage_key": "property/6767906449166345/019fd958-b58f-7762-bfd0-32cf2a26ccaf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://aither.yoga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14988467348564569886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aither-yoga",
      "poi_latitude": "40.43989699999999",
      "poi_longitude": "-80.0000706",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuS8ScYXxNIgRHm-7JqS7AdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b502c19-54b9-45c6-9ff0-5510375bd2f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Altus Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "808 Liberty Ave #3, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Friendly gym, popular for group classes and personal training, staffed by knowledgeable trainers and coaches who welcome visitors like family.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-b8db-7316-92c7-a88f52412f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-b8db-7316-92c7-a88f52412f6b",
        "storage_key": "property/6767906449166345/019fd958-b8db-7316-92c7-a88f52412f6b.webp",
        "width": 1280,
        "height": 877
      },
      "poi_business_url": "https://www.altus-hpo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8670259510098417189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altus-fitness",
      "poi_latitude": "40.442497",
      "poi_longitude": "-79.9988083",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-501-4154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBSyB1tDxNIgRJVbeYRbzUng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42b2de55-9ad5-4c27-80cc-5aa5115c9f39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "ClarkFit Boxing & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "433 Market St Floor 2, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-b613-72cd-b80c-86d645873583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-b613-72cd-b80c-86d645873583",
        "storage_key": "property/6767906449166345/019fd958-b613-72cd-b80c-86d645873583.webp",
        "width": 750,
        "height": 422
      },
      "poi_business_url": "http://www.clarkfitboxing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4218201713204082810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarkfit-boxing--fitness",
      "poi_latitude": "40.4411491",
      "poi_longitude": "-80.00251430000002",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-523-3563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmVtEmlbxNIgRejh58hsQijo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2403cf1b-3397-4060-88c8-ae10cd57907b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "California Cycle Path",
      "poi_type": "Health and Wellness",
      "poi_address": "3635 California Ave, Pittsburgh, PA 15212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-d45c-76dc-ac65-86af2514f815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-d45c-76dc-ac65-86af2514f815",
        "storage_key": "property/6767906449166345/019fd958-d45c-76dc-ac65-86af2514f815.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.californiacyclepath.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12094168712887476283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-cycle-path",
      "poi_latitude": "40.48115079999999",
      "poi_longitude": "-80.0416027",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-761-1671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaS6rZVr0NIgROyBN4V0e16c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74d50142-adb3-49cf-83e2-7d0df01fc5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Spa Jema",
      "poi_type": "Health and Wellness",
      "poi_address": "117 First Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-cfea-7548-87f3-fddb7f607349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-cfea-7548-87f3-fddb7f607349",
        "storage_key": "property/6767906449166345/019fd958-cfea-7548-87f3-fddb7f607349.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.spajema.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12726848441406754283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spa-jema",
      "poi_latitude": "40.4389269",
      "poi_longitude": "-80.0048745",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-281-3336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVtjklPxNIgR641ITDrZnrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc38f825-7169-4c92-90bb-954cb0f69ad8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Point State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Commonwealth Pl, Pittsburgh, PA 15222, USA",
      "poi_short_description": "36-acre park at the intersection of 3 rivers with boating, hiking, biking & a Fort Pitt museum.",
      "poi_long_description": "36-acre park at the intersection of 3 rivers with boating, hiking, biking & a Fort Pitt museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-c6a6-734c-9643-8a1ad85c51f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-c6a6-734c-9643-8a1ad85c51f7",
        "storage_key": "property/6767906449166345/019fd958-c6a6-734c-9643-8a1ad85c51f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pa.gov/agencies/dcnr/recreation/where-to-go/state-parks/find-a-park/point-state-park.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4515109341854696608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-state-park",
      "poi_latitude": "40.4415719",
      "poi_longitude": "-80.00785379999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-565-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbGBQav2NIgRoARMOwbkqD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_078eaa71-9e23-4349-8e13-7ca978e7e258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Monongahela Wharf Landing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "414 Wood St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Riverfront park features a paved walking trail, flood-resistant native plants & waterside steps.",
      "poi_long_description": "Riverfront park features a paved walking trail, flood-resistant native plants & waterside steps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-d287-7505-8309-3d705e63aeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-d287-7505-8309-3d705e63aeea",
        "storage_key": "property/6767906449166345/019fd958-d287-7505-8309-3d705e63aeea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://riverlifepgh.org/riverfront-guide/monongahela-wharf-landing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=54140278608943700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monongahela-wharf-landing",
      "poi_latitude": "40.43745089999999",
      "poi_longitude": "-80.004325",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-258-6636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXFJtlPxNIgRVNqG6ktYwAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c3d2f73c-8d21-4ebb-a3d6-3eebc4677774",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Allegheny Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 10th St BYP, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Narrow pedestrian park along Pittsburgh's river, with native plants & walkways on 2 levels.",
      "poi_long_description": "Narrow pedestrian park along Pittsburgh's river, with native plants & walkways on 2 levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-dd9c-756a-b8b5-520348ec578a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-dd9c-756a-b8b5-520348ec578a",
        "storage_key": "property/6767906449166345/019fd958-dd9c-756a-b8b5-520348ec578a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trustarts.org/pct_home/visual-arts/public-art/allegheny-riverfront-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7868581195607406226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allegheny-riverfront-park",
      "poi_latitude": "40.444562",
      "poi_longitude": "-80.0023533",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRRH-P3zNIgRknZ_aujQMm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ae7422a-1ddb-4f08-971a-b2f239b7de0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Market Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Pittsburgh, PA 15222, USA",
      "poi_short_description": "Redeveloped downtown square founded in 1764, now with farmers' markets, food trucks & bar terraces.",
      "poi_long_description": "Redeveloped downtown square founded in 1764, now with farmers' markets, food trucks & bar terraces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-eb27-77b5-b76a-bcd940d88a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-eb27-77b5-b76a-bcd940d88a2a",
        "storage_key": "property/6767906449166345/019fd958-eb27-77b5-b76a-bcd940d88a2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://marketsquarepgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13156338553733559463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-square",
      "poi_latitude": "40.4407817",
      "poi_longitude": "-80.00248359999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf9S9olbxNIgRp7QQmDW0lLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7792d71b-d41a-44c5-bde3-e5ea3136b8be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "PPG Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Third Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Glittery plaza with a central fountain that kids can splash in during warmer months.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-ea78-77a8-b302-f8f54b3df573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-ea78-77a8-b302-f8f54b3df573",
        "storage_key": "property/6767906449166345/019fd958-ea78-77a8-b302-f8f54b3df573.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18196841595702590598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppg-plaza",
      "poi_latitude": "40.4397847",
      "poi_longitude": "-80.0031747",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_n4ZhLxNIgRhrznMQUriPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7a4c53f5-db9f-4d0a-a42e-fbd0ad8cc5db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Mellon Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sixth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Dubbed the emerald oasis, this restored iconic site offers trees, lighted fountains & entertainment.",
      "poi_long_description": "Dubbed the emerald oasis, this restored iconic site offers trees, lighted fountains & entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-fe8a-758c-997e-50a27507ed23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-fe8a-758c-997e-50a27507ed23",
        "storage_key": "property/6767906449166345/019fd958-fe8a-758c-997e-50a27507ed23.webp",
        "width": 962,
        "height": 660
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13651568180512929373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellon-square",
      "poi_latitude": "40.4409603",
      "poi_longitude": "-79.9974896",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-682-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwQn2FnxNIgRXbZ_Wu4cdL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_262604ac-5f5b-44ef-a7ff-41ca7a5cf9ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Monongahela Incline at Lower Station",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Pittsburgh, PA 15203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-fa72-733c-9aed-eefbd2ef59ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-fa72-733c-9aed-eefbd2ef59ea",
        "storage_key": "property/6767906449166345/019fd958-fa72-733c-9aed-eefbd2ef59ea.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555213029395690991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monongahela-incline-at-lower-station",
      "poi_latitude": "40.4325049",
      "poi_longitude": "-80.004886",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWXOtk3xNIgR73Xgf27KHbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c47da21-e10d-474c-b0d3-6301e6399500",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Duquesne Incline",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1197 W Carson St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Opened in 1877, this landmark incline railway offers sweeping views of the city & a history museum.",
      "poi_long_description": "Opened in 1877, this landmark incline railway offers sweeping views of the city & a history museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-03bf-70c8-96df-94e71e0c6b8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-03bf-70c8-96df-94e71e0c6b8a",
        "storage_key": "property/6767906449166345/019fd959-03bf-70c8-96df-94e71e0c6b8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.duquesneincline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16749400193023290243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duquesne-incline",
      "poi_latitude": "40.439898",
      "poi_longitude": "-80.01761049999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-381-1665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNblqnq_2NIgRgysDwrvSceg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc486e98-df70-4ed8-809d-999797708d3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Allegheny Landing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Pittsburgh, PA 15212, USA",
      "poi_short_description": "This green space on the Allegheny River has sculptures & is a popular picnic & boat launch spot.",
      "poi_long_description": "This green space on the Allegheny River has sculptures & is a popular picnic & boat launch spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-02e5-75ca-85bc-587c0d8f2003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-02e5-75ca-85bc-587c0d8f2003",
        "storage_key": "property/6767906449166345/019fd959-02e5-75ca-85bc-587c0d8f2003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://riverlifepgh.org/riverfront-guide/allegheny-landing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12159523658676398326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allegheny-landing",
      "poi_latitude": "40.4469743",
      "poi_longitude": "-80.00335799999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-258-6636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbc7-72f1-8cd9-32cdec645b2a",
        "storage_key": "property/6767906449166345/019d026b-bbc7-72f1-8cd9-32cdec645b2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJve1xK_zzNIgR9mhd-VdOv6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d07cbb6c-07f2-4b9c-b0e4-1dcbb50f4409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Gateway Center Garage",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 Liberty Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-14c1-754a-81a1-543122318d2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-14c1-754a-81a1-543122318d2b",
        "storage_key": "property/6767906449166345/019fd959-14c1-754a-81a1-543122318d2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkpgh.org/lots/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=14842882631121217788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-center-garage",
      "poi_latitude": "40.4401648",
      "poi_longitude": "-80.0059455",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-c188-742e-97a8-6effc0de03fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-c188-742e-97a8-6effc0de03fc",
        "storage_key": "property/6767906449166345/019d026b-c188-742e-97a8-6effc0de03fc.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJhZTvfVTxNIgR_KjLrhyD_M0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a0fd5a9a-6b5f-41bd-94d4-47db4a539716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "First Avenue Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-14dd-779e-8555-f751b230230c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-14dd-779e-8555-f751b230230c",
        "storage_key": "property/6767906449166345/019fd959-14dd-779e-8555-f751b230230c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15757346131892628795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-avenue-station",
      "poi_latitude": "40.435574",
      "poi_longitude": "-79.996468",
      "poi_miles_from_property": "118 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxclllrxNIgRO-1VKtJWrdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_961a9252-dd56-4794-9601-cd4067d69692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Steel Plaza Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-1c12-748a-93ea-058b6e6b35fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-1c12-748a-93ea-058b6e6b35fb",
        "storage_key": "property/6767906449166345/019fd959-1c12-748a-93ea-058b6e6b35fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14088979914448582220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steel-plaza-station",
      "poi_latitude": "40.439794",
      "poi_longitude": "-79.995653",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZvZkFnxNIgRTDZS6JUchsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83607744-04ff-456b-8821-56c6052de853",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Wood St Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pittsburgh, PA 15226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-1afe-722c-9239-ab85265a6538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-1afe-722c-9239-ab85265a6538",
        "storage_key": "property/6767906449166345/019fd959-1afe-722c-9239-ab85265a6538.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13163930484801388004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wood-st-station",
      "poi_latitude": "40.4423602",
      "poi_longitude": "-79.9995572",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwg2r1fxNIgR5L2Fygetr7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a3b90425-c7b1-469c-905f-506375122c0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Four Gateway Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "444 Liberty Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-36b6-713a-baa4-e161bd4b1b03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-36b6-713a-baa4-e161bd4b1b03",
        "storage_key": "property/6767906449166345/019fd959-36b6-713a-baa4-e161bd4b1b03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1527705190525936183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-gateway-center",
      "poi_latitude": "40.4409236",
      "poi_longitude": "-80.00455269999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67GSalTxNIgRN6LR0sZ_MxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9de5cb5d-0803-4e37-a1b7-febb5025f334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Red Garage A - Grant Street Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "55 11th St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-29ca-75e1-8171-4710b04aa7e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-29ca-75e1-8171-4710b04aa7e5",
        "storage_key": "property/6767906449166345/019fd959-29ca-75e1-8171-4710b04aa7e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pittsburghparking.com/Facilities/Grant-Street-Transportation-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14594927211643145236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-garage-a---grant-street-transportation-center",
      "poi_latitude": "40.44467090000001",
      "poi_longitude": "-79.993275",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-560-2003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-c188-742e-97a8-6effc0de03fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-c188-742e-97a8-6effc0de03fc",
        "storage_key": "property/6767906449166345/019d026b-c188-742e-97a8-6effc0de03fc.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0BwPeLzNIgRFAysxPiYi8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ceccd0e0-31bd-45fb-8ca7-abb8edfd5e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Pittsburgh Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1100 Liberty Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-305c-7698-b0a2-bb3374cfeb2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-305c-7698-b0a2-bb3374cfeb2b",
        "storage_key": "property/6767906449166345/019fd959-305c-7698-b0a2-bb3374cfeb2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=PGH",
      "poi_directions_map_url": "https://maps.google.com/?cid=7926280578091270453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-union-station",
      "poi_latitude": "40.4446786",
      "poi_longitude": "-79.9915525",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-c18c-732a-81bc-10f202255e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-c18c-732a-81bc-10f202255e21",
        "storage_key": "property/6767906449166345/019d026b-c18c-732a-81bc-10f202255e21.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7Hin1jxNIgRNUE1xzDO_20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0421b07c-19ca-4c3d-b269-458f6e4b2ff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "1000 Airport Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "1000 Airport Blvd, Coraopolis, PA 15108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3661291669012987944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1000-airport-blvd",
      "poi_latitude": "40.4955466",
      "poi_longitude": "-80.25685299999999",
      "poi_miles_from_property": "22.9 mi",
      "poi_walking_minutes": "8 hours 47 mins",
      "poi_biking_minutes": "3 hours 5 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWAr3MJcNIgRKMCd5l-FzzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f0d5e39-b86a-41dc-bc1e-b5a04f9721b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Healthy Ride Bike Sharing Station - Liberty Ave & Stanwix St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Liberty Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=952472464831468211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthy-ride-bike-sharing-station---liberty-ave--stanwix-st",
      "poi_latitude": "40.4412138",
      "poi_longitude": "-80.0046086",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-535-5189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfx9x9FTxNIgRs9KeDKncNw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02d2d3bb-9428-41dd-9ffc-82db8e88bfd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "POGOH",
      "poi_type": "Transportation & Transit",
      "poi_address": "3328 Penn Ave, Pittsburgh, PA 15201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-3914-7349-a49c-104d2d2bec68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-3914-7349-a49c-104d2d2bec68",
        "storage_key": "property/6767906449166345/019fd959-3914-7349-a49c-104d2d2bec68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pogoh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9248400820305000202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pogoh",
      "poi_latitude": "40.4618363",
      "poi_longitude": "-79.9681758",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-595-9421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzJkjYHzNIgRCve1wovrWIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_004146ac-b5fd-457d-944d-6ff8474e8641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "UPMC Mercy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1400 Locust St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-a63f-7018-bd5e-d9f842ec6179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-a63f-7018-bd5e-d9f842ec6179",
        "storage_key": "property/6767906449166345/019fd958-a63f-7018-bd5e-d9f842ec6179.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.upmc.com/locations/hospitals/mercy?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-swpa-upmc-mercy",
      "poi_directions_map_url": "https://maps.google.com/?cid=8244303519153733630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-mercy",
      "poi_latitude": "40.4364439",
      "poi_longitude": "-79.985575",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-232-8111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbdd-75bd-86c8-b59998843069.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbdd-75bd-86c8-b59998843069",
        "storage_key": "property/6767906449166345/019d026b-bbdd-75bd-86c8-b59998843069.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsesVYGfxNIgR_j-p116maXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7327a671-9a96-492f-8306-29e4d2d255a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Allegheny County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "436 Grant St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Landmark built in romanesque revival style, featuring turreted towers & an interior courtyard.",
      "poi_long_description": "Landmark built in romanesque revival style, featuring turreted towers & an interior courtyard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-44c1-7612-a196-651d599f2f0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-44c1-7612-a196-651d599f2f0c",
        "storage_key": "property/6767906449166345/019fd959-44c1-7612-a196-651d599f2f0c.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "http://www.alleghenycourts.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5295232706788827058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allegheny-county-courthouse",
      "poi_latitude": "40.4388408",
      "poi_longitude": "-79.99593150000001",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 412-350-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-c190-75bc-9fb2-d8c831ed97ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-c190-75bc-9fb2-d8c831ed97ea",
        "storage_key": "property/6767906449166345/019d026b-c190-75bc-9fb2-d8c831ed97ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0z4HlrxNIgRsp8taxdyfEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f32d0f67-5eb9-4fa4-a7fe-c59796d94a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "BNY Wealth Pittsburgh",
      "poi_type": "Major Employers & Offices",
      "poi_address": "BNY Mellon Center, 500 Grant St Suite 3700, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-3c24-7688-94f5-59bb6537abac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-3c24-7688-94f5-59bb6537abac",
        "storage_key": "property/6767906449166345/019fd959-3c24-7688-94f5-59bb6537abac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bny.com/wealth/global/en/about-us/locations/pittsburgh.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10755415346542351659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bny-wealth-pittsburgh",
      "poi_latitude": "40.4396569",
      "poi_longitude": "-79.9958004",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-234-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYa1uklnxNIgRKxVx5kXpQpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0fefaab-89ef-4f69-8e09-c753c811edb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "The Tower at PNC Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-5227-76c2-9e34-c8b056f1da93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-5227-76c2-9e34-c8b056f1da93",
        "storage_key": "property/6767906449166345/019fd959-5227-76c2-9e34-c8b056f1da93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pnc.com/en/about-pnc.html?lnksrc=corp-listing-google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15727335626315097830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tower-at-pnc-plaza",
      "poi_latitude": "40.440529",
      "poi_longitude": "-80.000289",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-762-2265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TEyIVfxNIgR5mbb1Wy4Qto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a1f163a6-3911-4ec8-b0ae-43251c16a4fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Highmark Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-599b-76f9-9ea7-df00b27dbeee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-599b-76f9-9ea7-df00b27dbeee",
        "storage_key": "property/6767906449166345/019fd959-599b-76f9-9ea7-df00b27dbeee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.highmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15507996705669340876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highmark-corporate-headquarters",
      "poi_latitude": "40.4419235",
      "poi_longitude": "-80.00317319999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-544-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZ51f1bxNIgRzF5Zw9Z4N9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_634f869f-5ff0-406a-babc-96b5cd19373c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Point Park University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Wood St, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-70b9-75b3-ba60-639b7e8179c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-70b9-75b3-ba60-639b7e8179c4",
        "storage_key": "property/6767906449166345/019fd958-70b9-75b3-ba60-639b7e8179c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pointpark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793739138826593381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-park-university",
      "poi_latitude": "40.4384916",
      "poi_longitude": "-80.0017987",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-391-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx2ZxR1HxNIgRZWSZeNtZ6oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c894608a-38da-47c7-b9e6-80b7a29b6331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Duquesne University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Forbes Ave, Pittsburgh, PA 15282, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd958-6223-719a-bedd-317081223bc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd958-6223-719a-bedd-317081223bc0",
        "storage_key": "property/6767906449166345/019fd958-6223-719a-bedd-317081223bc0.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.duq.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14522005983332821861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duquesne-university",
      "poi_latitude": "40.4369485",
      "poi_longitude": "-79.99025759999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-396-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3PD-1vxNIgRZWumPoCHiMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_65f093b6-3c24-4fa9-8e77-b1336cb86739",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "University of Pittsburgh",
      "poi_type": "Education",
      "poi_address": "4200 Fifth Ave, Pittsburgh, PA 15260, USA",
      "poi_short_description": "Founded in 1787, this research university is known for health sciences, education & engineering.",
      "poi_long_description": "Founded in 1787, this research university is known for health sciences, education & engineering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-5d60-70ab-867a-31c426d4cef5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-5d60-70ab-867a-31c426d4cef5",
        "storage_key": "property/6767906449166345/019fd959-5d60-70ab-867a-31c426d4cef5.webp",
        "width": 923,
        "height": 1280
      },
      "poi_business_url": "https://www.pitt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5972082850565172495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-pittsburgh",
      "poi_latitude": "40.4444842",
      "poi_longitude": "-79.9612831",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-624-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-b53b-749d-9f5e-95dc62ade2ce",
        "storage_key": "property/6767906449166345/019d026b-b53b-749d-9f5e-95dc62ade2ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH_Fa2SvyNIgRD60jDbYZ4VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b90f94a2-7272-4ae3-a831-3b417522985b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "PPG Industries Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 PPG Pl, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Skyscraper resembling a castle turret, covered in reflective glass & set on a plaza with fountains.",
      "poi_long_description": "Skyscraper resembling a castle turret, covered in reflective glass & set on a plaza with fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-5d14-7726-b2f3-8ef883d85937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-5d14-7726-b2f3-8ef883d85937",
        "storage_key": "property/6767906449166345/019fd959-5d14-7726-b2f3-8ef883d85937.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ppg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206431020168479959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppg-industries-inc",
      "poi_latitude": "40.4398819",
      "poi_longitude": "-80.0034788",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-434-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-bbaf-7568-a7d8-f7cd16be839f",
        "storage_key": "property/6767906449166345/019d026b-bbaf-7568-a7d8-f7cd16be839f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZy_A1TxNIgR14RHLjzQw38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1101e011-20cd-4453-b83c-aa21f72b34f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "poi_name": "Joseph F. Weis. Jr. U.S. Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Grant St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fd959-67ee-703b-a3d2-91c30acc4d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd959-67ee-703b-a3d2-91c30acc4d87",
        "storage_key": "property/6767906449166345/019fd959-67ee-703b-a3d2-91c30acc4d87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pawd.uscourts.gov/pittsburgh-courthouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=10475726985651680128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-f-weis-jr-us-courthouse",
      "poi_latitude": "40.4427927",
      "poi_longitude": "-79.9940596",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019d026b-c190-75bc-9fb2-d8c831ed97ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-c190-75bc-9fb2-d8c831ed97ea",
        "storage_key": "property/6767906449166345/019d026b-c190-75bc-9fb2-d8c831ed97ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbQ4kljxNIgRgPO9zzBCYZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_dcd47928a6780cd73d6e6b2a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bddee3dfdf639f94e0dda726",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5ec85f081a359f0e1e25b0c2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_de2e40cc4fabf0beed2266ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3ce000ec945477985d7c29a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_75ee850a3f07990aefc2b68f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d9598a5382e0c81ae3e756a0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "rating": "5",
      "name": "false",
      "text": "Great layouts with modern amenities and fantastic social areas! Definitely at the top of my search list. Just toured today with Derrick who is an awesome agent. It feels like a good fit for me. ",
      "date": "false",
      "title": "Very impressive "
    },
    {
      "id": "ec_8bc3131ccc805c6dfca4d1df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "rating": "5",
      "name": "false",
      "text": "I just toured the property and from what I experienced the building takes full advantage of its industrial roots and gives off the vibe of a very cool artistic type of atmosphere. The apartments felt just like the urban style lofts they are advertised as (with big windows and lots of light) and all of the community spaces perfectly compliment everything I just described for what I expect will create an overall cool and energetic place to call home. And while I can admit that I am not a fan of the AI answering service you have to get past when calling, once you do reach the actual staff they are super helpful, knowledgeable, friendly and quick to answer any questions and concerns. Lastly, the location is fantastic. With easy access to multiple highways, you can easily get to any side of the city easily avoiding traffic, yet you’re still just a couple of blocks walk away from everything. In my opinion, Terminal 21 seems like a really great deal for the price and I really look forward to taking on the spirit of the city from that vantage point. ",
      "date": "false",
      "title": "Friendly Staff / Very Cool Building"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_baeb8fbe-61ff-4dce-886f-38efa2ef87f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/019fa941-c4b7-771f-a74e-ffd647ffa6c6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa941-c4b7-771f-a74e-ffd647ffa6c6",
        "storage_key": "property/6767906449166345/019fa941-c4b7-771f-a74e-ffd647ffa6c6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Terminal 21",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=63221634d1dcfd7d70f7951e&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_e7ac0825760bcced72443971",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429584",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_921fef839427e9746fa6e350",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429585",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6b87947896c6d4564d450626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429586",
      "name": "Motorcycle-Parking",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_944e56cca072aa9c29cfb506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429587",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3dc523cee47eea13aeaa547f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429588",
      "name": "Admin Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e7dc2185f496179be08f031b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429589",
      "name": "Garage-Large Parking",
      "description": "false",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a732a978c6b0e5ace96eea74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429590",
      "name": "Car + Motorcycle Parking",
      "description": "false",
      "amount": 275,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_228c62b0725e42c63cea188c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429591",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_139c0334b78ef500b9c6cee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429594",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0cff8a7718e5e46f6cb269fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429595",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9874a93e57c17962cdb296c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "429596",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5d58975dda4a3368df6e2805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567360",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a1725dc848591fb3d39ce23e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567361",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f0e343b02921bcecf6dcb486",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567362",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_04068ae428f239ec61f2808c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567363",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_567d5f589f1f8a61e883a76b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567364",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3be87aebdd19e207e287017e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "567368",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0ef75096fc4ab11540b3a4d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "741821",
      "name": "Pest Control",
      "description": "false",
      "amount": 3,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_77abe06d94f976ac7bedcdf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "832531",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_373a646f07dcc59ebdc74a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "832533",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a6cd1cf426c068d5b59acedb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "832535",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_08c3235f2052b328ca089a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "832536",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 125,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4e044653b980b8af5a836414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "832550",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6fff01a4c280a04ffb2ad631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "engrain",
      "external_id": "835280",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1325-c406-708d-a97c-b68551820657",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-terminal-21-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345"
    },
    {
      "lead_collector_id": "019c3043-9a2e-73a8-99df-0f7ce36a0763",
      "lead_source": "FACEBOOK_ADS",
      "name": "terminal-21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345"
    },
    {
      "lead_collector_id": "019c3043-9aa9-7432-9e5f-a466809aa020",
      "lead_source": "LANDING_PAGE",
      "name": "terminal-21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-downtown-pittsburgh-terminal-21-370",
      "search_query": "pet friendly apartments downtown Pittsburgh",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Downtown Pittsburgh",
      "h2_subtitle": "Loft-style studio, one and two bedroom apartments with an on-site dog park and pet wash in 15219",
      "page_copy": "Looking for pet-friendly apartments in Downtown Pittsburgh? Terminal 21 welcomes pets with an on-site dog park and a dedicated pet wash station, so muddy paws never make it past the lobby. Our loft-style studio, one and two bedroom apartments sit at 615 First Avenue in the 15219 zip, close to riverfront trails for longer walks.\n\nInside, homes feature 11 foot ceilings, oversized windows, exposed concrete floors and kitchens with quartz countertops, stainless steel appliances and a dishwasher. In-home washers and dryers are available, and every floor has a laundry room. When you need a break from pet duty, unwind in the speakeasy lounge, game room or 24-hour fitness center. Amazon Hub lockers, a controlled-access building and on-site management and maintenance make city living easy. Schedule a tour of our pet-friendly apartments in Downtown Pittsburgh today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d53-73d2-707d-a926-08af0ee167dd.webp",
      "featured_image_media": {
        "alt_text": "Artificial turf lawn area with a black metal fence in front of a brick building.",
        "public_id": "01a13d53-73d2-707d-a926-08af0ee167dd",
        "storage_key": "property/6767906449166345/01a13d53-73d2-707d-a926-08af0ee167dd.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Downtown Pittsburgh | Terminal 21",
      "seo_description": "Pet-friendly apartments in Downtown Pittsburgh with an on-site dog park and pet wash station. Loft-style studios, 1 and 2 bedrooms at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "luxury-apartments-speakeasy-lounge-pittsburgh-pa-terminal-21-352",
      "search_query": "luxury apartments with speakeasy lounge Pittsburgh PA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with a Speakeasy Lounge in Pittsburgh",
      "h2_subtitle": "Downtown Pittsburgh lofts with a resident speakeasy lounge, coffee bar, game room and caterer kitchen",
      "page_copy": "Terminal 21 offers luxury apartments in Pittsburgh, PA with something most buildings do not: a resident speakeasy lounge. Meet friends for a drink without leaving home, then head to the arcade and billiards room or the coffee bar. Hosting a bigger night? The caterer kitchen and resident lounge make it easy.\n\nOur loft-style studio, one and two bedroom apartments in Downtown Pittsburgh feature 11 foot ceilings, oversized windows, quartz countertops, stainless steel appliances and a kitchen island, with city and river views from select homes. Residents also enjoy a 24-hour fitness center, yoga studio, dog park and pet wash, plus Amazon Hub lockers and a controlled-access building. First Avenue Station is steps away when you want to explore the rest of the city. Schedule a tour of Terminal 21 and see the speakeasy for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d54-7fc2-779c-860d-97f572bc4900.webp",
      "featured_image_media": {
        "alt_text": "Modern lounge area with plush seating, tables, and a bar in the background.",
        "public_id": "01a13d54-7fc2-779c-860d-97f572bc4900",
        "storage_key": "property/6767906449166345/01a13d54-7fc2-779c-860d-97f572bc4900.webp",
        "width": 1600,
        "height": 1069
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Speakeasy Lounge Pittsburgh | T21",
      "seo_description": "Luxury apartments in Pittsburgh, PA with a resident speakeasy lounge, coffee bar and game room. Loft-style studios, 1 and 2 bedrooms at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "co-working-lounge-apartments-allegheny-county-terminal-21-267",
      "search_query": "co-working lounge apartments Allegheny County",
      "category": "Amenity",
      "h1_title": "Apartments with a Co-Working Lounge in Allegheny County",
      "h2_subtitle": "Work from home without working from your couch: co-working lounge, work pods, conference room and podcast room",
      "page_copy": "Terminal 21 is built for people who work from home in Allegheny County. Our co-working lounge gives you a dedicated place to focus, with private work pods for calls, a conference room you can reserve for meetings and Wi-Fi throughout the common areas. Creators can use the podcast room and the maker's room, and the coffee bar keeps the day moving.\n\nWhen the workday ends, your loft-style studio, one or two bedroom apartment is an elevator ride away, with 11 foot ceilings, oversized windows and a kitchen with quartz countertops and stainless steel appliances. Take a break in the 24-hour fitness center or yoga studio, or meet neighbors in the speakeasy lounge. If you do head into the office, First Avenue Station and PRT bus routes are steps from our Downtown Pittsburgh address. Schedule a tour of our co-working lounge apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d54-c953-773f-b1a5-2e7234e1c058.webp",
      "featured_image_media": {
        "alt_text": "Modern co-working space with a long conference table and lounge seating.",
        "public_id": "01a13d54-c953-773f-b1a5-2e7234e1c058",
        "storage_key": "property/6767906449166345/01a13d54-c953-773f-b1a5-2e7234e1c058.webp",
        "width": 1600,
        "height": 1069
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Co-Working Lounge Apartments Allegheny County | Terminal 21",
      "seo_description": "Apartments with a co-working lounge in Allegheny County. Work pods, a conference room, podcast room and common-area Wi-Fi at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-with-fitness-center-pittsburgh-15219-terminal-21-985",
      "search_query": "apartments with fitness center Pittsburgh 15219",
      "category": "Amenity",
      "h1_title": "Apartments with a Fitness Center in Pittsburgh 15219",
      "h2_subtitle": "A 24-hour fitness center, yoga studio and bike storage and repair station in Downtown Pittsburgh",
      "page_copy": "Skip the gym membership. Terminal 21 offers apartments with a 24-hour fitness center in Pittsburgh's 15219 zip, so you can train before work, after work or at midnight. Our separate yoga studio gives you space to stretch, and the bike storage and repair station keeps your ride ready for the riverfront trails nearby.\n\nHome is a loft-style studio, one or two bedroom apartment with 11 foot ceilings, oversized windows, exposed concrete floors and a kitchen with quartz countertops, stainless steel appliances and a dishwasher. In-home washers and dryers are available, and there is a laundry room on every floor. Residents also enjoy a speakeasy lounge, coffee bar, dog park and Amazon Hub lockers, all in a controlled-access building with on-site management and maintenance. Schedule a tour of our apartments with a fitness center in Downtown Pittsburgh today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d55-0ff3-7178-8923-b0c7ef9a6c49.webp",
      "featured_image_media": {
        "alt_text": "A modern fitness center with treadmills, ellipticals, and a spin bike, featuring a vibrant lion mural on the wall.",
        "public_id": "01a13d55-0ff3-7178-8923-b0c7ef9a6c49",
        "storage_key": "property/6767906449166345/01a13d55-0ff3-7178-8923-b0c7ef9a6c49.webp",
        "width": 1600,
        "height": 1069
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Pittsburgh 15219 | Terminal 21",
      "seo_description": "Apartments with a 24-hour fitness center in Pittsburgh 15219. Yoga studio, bike storage and repair, and loft-style homes at Terminal 21 Downtown. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "dog-park-apartments-in-pittsburgh-pa-terminal-21-47",
      "search_query": "dog park apartments in Pittsburgh PA",
      "category": "Amenity",
      "h1_title": "Apartments with a Dog Park in Pittsburgh, PA",
      "h2_subtitle": "An on-site dog park and pet wash station at loft-style apartments in Downtown Pittsburgh",
      "page_copy": "Terminal 21 offers apartments with a dog park in Pittsburgh, PA, right on site. Our outdoor dog park gives your pup a safe place to run and play without a trip across town, and the pet wash station makes cleanup simple. It is a rare combination in Downtown Pittsburgh, where green space for dogs can be hard to find.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows and exposed concrete floors that stand up to paws. Kitchens include quartz countertops, stainless steel appliances and a dishwasher, and in-home washers and dryers are available. Beyond the dog park, residents enjoy a 24-hour fitness center, speakeasy lounge, coffee bar and Amazon Hub lockers, plus on-site management and maintenance. Schedule a tour of our dog park apartments in Pittsburgh today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d57-2937-76c2-9be5-f6528fad8770.webp",
      "featured_image_media": {
        "alt_text": "Enclosed outdoor dog park with artificial turf, a pet waste station, and a green trash can next to a building.",
        "public_id": "01a13d57-2937-76c2-9be5-f6528fad8770",
        "storage_key": "property/6767906449166345/01a13d57-2937-76c2-9be5-f6528fad8770.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Pittsburgh, PA | Terminal 21",
      "seo_description": "Apartments with an on-site dog park in Pittsburgh, PA. Pet wash station and pet-friendly loft-style studios, 1 and 2 bedrooms at Terminal 21. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "studio-apartments-downtown-pittsburgh-terminal-21-55",
      "search_query": "studio apartments downtown Pittsburgh",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Downtown Pittsburgh",
      "h2_subtitle": "Loft-style studios from 404 to 585 sq ft with 11 foot ceilings and oversized windows in 15219",
      "page_copy": "Terminal 21 offers studio apartments in Downtown Pittsburgh with seven loft-style layouts from 404 to 585 sq ft. Thanks to 11 foot ceilings and oversized windows, our studios feel bigger than their footprint, and the open layout makes it easy to set up a living area, workspace and bedroom.\n\nEvery studio includes a kitchen with quartz countertops, stainless steel appliances, a microwave and a dishwasher, plus air conditioning, recessed lighting and a walk-in closet in many layouts. In-home washers and dryers are available, and there is a laundry room on every floor. Because studios trade square footage for location, our shared spaces do the rest: a co-working lounge, speakeasy lounge, 24-hour fitness center, yoga studio, coffee bar and game room. First Avenue Station is steps away. Check availability on our Downtown Pittsburgh studio apartments and schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d59-b340-76ff-bfbc-a804d52167a2.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment living room and kitchen with stainless steel appliances and a sectional sofa.",
        "public_id": "01a13d59-b340-76ff-bfbc-a804d52167a2",
        "storage_key": "property/6767906449166345/01a13d59-b340-76ff-bfbc-a804d52167a2.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Downtown Pittsburgh | Terminal 21",
      "seo_description": "Studio apartments in Downtown Pittsburgh from 404 to 585 sq ft. 11 foot ceilings, oversized windows and quartz kitchens at Terminal 21. Check availability.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-allegheny-county-pa-terminal-21-639",
      "search_query": "one bedroom apartments in Allegheny County PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Allegheny County, PA",
      "h2_subtitle": "Loft-style one bedroom apartments from 551 to 784 sq ft in Downtown Pittsburgh's 15219 zip",
      "page_copy": "Searching for one bedroom apartments in Allegheny County, PA? Terminal 21 offers more than a dozen loft-style one bedroom layouts from 551 to 784 sq ft in Downtown Pittsburgh. Each one has a separate bedroom with carpeting, plus an open living and kitchen area under 11 foot ceilings with oversized windows.\n\nKitchens feature quartz countertops, stainless steel appliances, a subway tile backsplash, a dishwasher and, in many layouts, a kitchen island. Bathrooms are renovated, walk-in closets are common, and in-home washers and dryers are available. Select homes have city and river views. Downstairs, you will find a co-working lounge, speakeasy lounge, 24-hour fitness center, yoga studio and dog park, and First Avenue Station is steps from the front door. Check availability on our one bedroom apartments and schedule a tour of Terminal 21 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d59-fd75-70e1-958c-92b59cb897e3.webp",
      "featured_image_media": {
        "alt_text": "Bedroom with a queen-size bed, large windows, and artwork.",
        "public_id": "01a13d59-fd75-70e1-958c-92b59cb897e3",
        "storage_key": "property/6767906449166345/01a13d59-fd75-70e1-958c-92b59cb897e3.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Allegheny County PA | Terminal 21",
      "seo_description": "One bedroom apartments in Allegheny County, PA from 551 to 784 sq ft. Loft-style homes with 11 foot ceilings and quartz kitchens at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-15219-terminal-21-371",
      "search_query": "two bedroom apartments 15219",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Pittsburgh 15219",
      "h2_subtitle": "Two bedroom, two bath lofts from 859 to 1,324 sq ft in Downtown Pittsburgh, ideal for roommates",
      "page_copy": "Terminal 21 offers two bedroom apartments in the 15219 zip with two full bathrooms in every layout, from 859 to 1,324 sq ft. That means no sharing a bathroom with a roommate, and plenty of space for a home office, guest room or growing household in the middle of Downtown Pittsburgh.\n\nOur loft-style two bedrooms feature 11 foot ceilings, oversized windows, exposed concrete living areas and carpeted bedrooms. Kitchens include quartz countertops, stainless steel appliances, a dishwasher and, in many layouts, a kitchen island. In-home washers and dryers are available, walk-in closets are common and select homes have city and river views. Residents share a co-working lounge, speakeasy lounge, 24-hour fitness center, yoga studio and dog park, and on-site parking is available. Check availability on our two bedroom apartments in 15219 and schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d5a-4410-73e4-8494-ed3c38b09fbf.webp",
      "featured_image_media": {
        "alt_text": "Spacious loft-style living room with a large blue sectional sofa, accent chair, coffee table, and dining area.",
        "public_id": "01a13d5a-4410-73e4-8494-ed3c38b09fbf",
        "storage_key": "property/6767906449166345/01a13d5a-4410-73e4-8494-ed3c38b09fbf.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Pittsburgh 15219 | Terminal 21",
      "seo_description": "Two bedroom, two bath apartments in Pittsburgh 15219 from 859 to 1,324 sq ft. Loft-style homes with quartz kitchens and city views at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-near-point-park-university-terminal-21-119",
      "search_query": "apartments near point park university downtown pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near Point Park University in Downtown Pittsburgh",
      "h2_subtitle": "Loft-style apartments a short walk from Point Park University's Downtown Pittsburgh campus",
      "page_copy": "Terminal 21 offers apartments near Point Park University, a short walk across Downtown Pittsburgh from our home at 615 First Avenue. Students, faculty and staff can skip the commute and still have room to breathe in a loft-style studio, one or two bedroom apartment with 11 foot ceilings and oversized windows.\n\nStudy in our co-working lounge or a private work pod, record in the podcast room or grab a coffee at the coffee bar between classes. When it is time to recharge, the 24-hour fitness center, yoga studio, game room and speakeasy lounge are all downstairs. Two bedroom, two bath layouts work well for roommates, and in-home washers and dryers are available. First Avenue Station and PRT bus routes are steps away for trips to the rest of the city. Schedule a tour of our apartments near Point Park University today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d5a-cddd-7520-83c7-3e67d14aa53f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the Pittsburgh Playhouse at Point Park University",
        "public_id": "01a13d5a-cddd-7520-83c7-3e67d14aa53f",
        "storage_key": "property/6767906449166345/01a13d5a-cddd-7520-83c7-3e67d14aa53f.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Point Park University | Terminal 21",
      "seo_description": "Apartments near Point Park University in Downtown Pittsburgh. Loft-style studios, 1 and 2 bedrooms and a co-working lounge at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "terminal-21-apartments-close-to-duquesne-university-73",
      "search_query": "terminal 21 apartments close to duquesne university",
      "category": "School",
      "h1_title": "Apartments Near Duquesne University in Pittsburgh",
      "h2_subtitle": "Downtown Pittsburgh lofts a short walk from Duquesne University's Bluff campus, ideal for grad students and staff",
      "page_copy": "Terminal 21 offers apartments near Duquesne University, a short walk from our Downtown Pittsburgh address to the Bluff campus. It is a convenient home for graduate students, faculty and staff who want city living without a long commute.\n\nChoose a loft-style studio, one or two bedroom apartment with 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances. Two bedroom, two bath layouts are a smart fit for roommates. Our co-working lounge, work pods and conference room give you quiet places to study, and the coffee bar, game room and speakeasy lounge are there when the books close. A 24-hour fitness center, yoga studio, dog park and laundry room on every floor round it out, with in-home washers and dryers available. Schedule a tour of our apartments near Duquesne University today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d5f-5cf3-76ae-809a-4d2feeb1c1d2.webp",
      "featured_image_media": {
        "alt_text": "Panoramic view of a city skyline with several apartment buildings and surrounding residential areas.",
        "public_id": "01a13d5f-5cf3-76ae-809a-4d2feeb1c1d2",
        "storage_key": "property/6767906449166345/01a13d5f-5cf3-76ae-809a-4d2feeb1c1d2.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Duquesne University | Terminal 21",
      "seo_description": "Apartments near Duquesne University in Downtown Pittsburgh. Loft-style studios, 1 and 2 bedrooms and a co-working lounge at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-near-carnegie-mellon-university-pittsburgh-15219-526",
      "search_query": "apartments near carnegie mellon university pittsburgh 15219",
      "category": "School",
      "h1_title": "Apartments Near Carnegie Mellon University",
      "h2_subtitle": "Downtown Pittsburgh lofts in 15219 with PRT bus routes to Oakland and the Carnegie Mellon campus",
      "page_copy": "Want to be near Carnegie Mellon University without living in student housing? Terminal 21 is in Downtown Pittsburgh's 15219 zip, with PRT bus routes nearby that connect Downtown to Oakland and the CMU campus. It is a good fit for graduate students, researchers and staff who want city amenities after class.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances. Two bedroom, two bath layouts work well for roommates. Study in the co-working lounge, take calls in a private work pod or record in the podcast room, then unwind in the speakeasy lounge or 24-hour fitness center. A dog park, pet wash and bike storage and repair station are on site, along with on-site parking. Schedule a tour of our apartments near Carnegie Mellon University today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d63-cf8e-738c-b5e9-0bb759c334b1.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a large, light-colored brick building with an arched entrance, surrounded by trees and a pathway.",
        "public_id": "01a13d63-cf8e-738c-b5e9-0bb759c334b1",
        "storage_key": "property/6767906449166345/01a13d63-cf8e-738c-b5e9-0bb759c334b1.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carnegie Mellon University | Terminal 21",
      "seo_description": "Apartments near Carnegie Mellon University with PRT bus access to Oakland. Loft-style studios, 1 and 2 bedrooms at Terminal 21 Downtown. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-close-to-pittsburgh-capa-terminal-21-29",
      "search_query": "apartments close to pittsburgh capa allegheny county",
      "category": "School",
      "h1_title": "Apartments Near Pittsburgh CAPA in Downtown Pittsburgh",
      "h2_subtitle": "Loft-style apartments near Pittsburgh CAPA and the Cultural District for families, faculty and staff",
      "page_copy": "Terminal 21 offers apartments near Pittsburgh CAPA, the public creative and performing arts school in Downtown Pittsburgh's Cultural District. From our home at 615 First Avenue, CAPA and the theaters along Penn Avenue are easy to reach, which makes Terminal 21 a convenient choice for CAPA families, teachers and staff in Allegheny County.\n\nOur loft-style one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances, and two bedroom, two bath layouts give families and roommates room to spread out. Creative types will appreciate the maker's room and podcast room, while the co-working lounge and work pods are ideal for grading or remote work. A 24-hour fitness center, yoga studio, dog park and on-site management and maintenance round out life at Terminal 21. Schedule a tour of our apartments near Pittsburgh CAPA today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d64-ca2f-762d-b450-cbbe3d3aeb7d.webp",
      "featured_image_media": {
        "alt_text": "Street view of buildings and a trolley on a sunny day",
        "public_id": "01a13d64-ca2f-762d-b450-cbbe3d3aeb7d",
        "storage_key": "property/6767906449166345/01a13d64-ca2f-762d-b450-cbbe3d3aeb7d.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh CAPA | Terminal 21",
      "seo_description": "Apartments near Pittsburgh CAPA in the Cultural District, Allegheny County. Loft-style 1 and 2 bedrooms and a maker's room at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "milliones-school-nearby-apartments-terminal-21-pittsburgh-760",
      "search_query": "milliones school nearby apartments terminal 21 pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near Pittsburgh Milliones 6-12",
      "h2_subtitle": "Two bedroom, two bath Downtown apartments a short drive from Pittsburgh Milliones in the Hill District",
      "page_copy": "Terminal 21 offers Downtown Pittsburgh apartments a short drive from Pittsburgh Milliones 6-12, the public school in the Hill District. For families and school staff, it means an easy trip up the hill in the morning and a home base in the center of the city.\n\nOur two bedroom, two bath apartments range from 859 to 1,324 sq ft, so parents and students each get their own bathroom. Every loft-style home features 11 foot ceilings, oversized windows, quartz countertops, stainless steel appliances and a dishwasher, with in-home washers and dryers available. The co-working lounge, work pods and Wi-Fi in common areas give everyone a quiet place for homework or remote work. On-site parking, a 24-hour fitness center, dog park and on-site management and maintenance make day-to-day life easy. Schedule a tour of Terminal 21 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d65-c53a-72f0-97cf-6460906f8612.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a historic brick building with a green roof, surrounded by bare trees and overgrown grass.",
        "public_id": "01a13d65-c53a-72f0-97cf-6460906f8612",
        "storage_key": "property/6767906449166345/01a13d65-c53a-72f0-97cf-6460906f8612.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Milliones School Pittsburgh | Terminal 21",
      "seo_description": "Apartments near Pittsburgh Milliones 6-12 in the Hill District. Two bedroom, two bath lofts in Downtown Pittsburgh at Terminal 21. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-near-upmc-mercy-pittsburgh-terminal-21-623",
      "search_query": "apartments near upmc mercy pittsburgh",
      "category": "Hospital",
      "h1_title": "Apartments Near UPMC Mercy in Pittsburgh",
      "h2_subtitle": "Downtown Pittsburgh lofts near UPMC Mercy on the Bluff for nurses, residents and healthcare staff",
      "page_copy": "Terminal 21 offers apartments near UPMC Mercy, just across Downtown from the hospital's campus on the Bluff. For nurses, residents and healthcare staff working long shifts, a short commute means more time to rest.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, carpeted bedrooms in one and two bedroom layouts, and kitchens with quartz countertops, stainless steel appliances and a dishwasher. In-home washers and dryers are available, which makes washing scrubs simple. After a shift, the 24-hour fitness center works around your schedule, and the coffee bar is there for early starts. A controlled-access building, on-site parking, Amazon Hub lockers and on-site management and maintenance add peace of mind. Schedule a tour of our apartments near UPMC Mercy today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-0507-713a-a3fb-4bd57e6c59e4.webp",
      "featured_image_media": {
        "alt_text": "Cityscape featuring UPMC and UPMC Mercy buildings on a hill.",
        "public_id": "01a13d61-0507-713a-a3fb-4bd57e6c59e4",
        "storage_key": "property/6767906449166345/01a13d61-0507-713a-a3fb-4bd57e6c59e4.webp",
        "width": 1600,
        "height": 788
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UPMC Mercy Pittsburgh | Terminal 21",
      "seo_description": "Apartments near UPMC Mercy in Pittsburgh for nurses and healthcare staff. Loft-style homes and a 24-hour fitness center at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-near-point-state-park-terminal-21-pittsburgh-995",
      "search_query": "apartments near point state park pittsburgh",
      "category": "Park",
      "h1_title": "Apartments Near Point State Park in Pittsburgh",
      "h2_subtitle": "Downtown lofts near Point State Park's fountain, riverfront trails and the confluence of Pittsburgh's three rivers",
      "page_copy": "Terminal 21 offers apartments near Point State Park, the 36-acre park at the tip of Downtown Pittsburgh where the Allegheny and Monongahela meet to form the Ohio River. Walk or bike along the riverfront to the park's signature fountain, catch a summer festival or simply enjoy the view from the lawn.\n\nBack home, our loft-style studio, one and two bedroom apartments feature 11 foot ceilings and oversized windows, with city and river views from select homes. Kitchens include quartz countertops, stainless steel appliances and a dishwasher, and in-home washers and dryers are available. Residents enjoy a 24-hour fitness center, yoga studio, bike storage and repair station, dog park and speakeasy lounge, all in a controlled-access building. Schedule a tour of our apartments near Point State Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-3430-750c-b6f5-817fe1abe7e1.webp",
      "featured_image_media": {
        "alt_text": "Large water fountain spraying water high into the air with people relaxing by the water in the background.",
        "public_id": "01a13d61-3430-750c-b6f5-817fe1abe7e1",
        "storage_key": "property/6767906449166345/01a13d61-3430-750c-b6f5-817fe1abe7e1.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Point State Park Pittsburgh | Terminal 21",
      "seo_description": "Apartments near Point State Park in Pittsburgh. Loft-style studios, 1 and 2 bedrooms with city and river views from select homes at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "terminal-21-close-to-monongahela-wharf-landing-58",
      "search_query": "terminal 21 close to monongahela wharf landing",
      "category": "Park",
      "h1_title": "Apartments Near the Mon Wharf Landing in Pittsburgh",
      "h2_subtitle": "Loft-style apartments a few blocks from the Mon Wharf Landing and the Monongahela riverfront trail",
      "page_copy": "Terminal 21 sits a few blocks from the Mon Wharf Landing, the riverfront park and trail along the Monongahela River in Downtown Pittsburgh. Head down for a morning run, a bike ride toward Point State Park or a quiet walk along the water after work.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings and oversized windows, with city and river views from select homes. Kitchens include quartz countertops, stainless steel appliances and a dishwasher, and in-home washers and dryers are available. Keep your bike ready in the bike storage and repair station, then cool down in the 24-hour fitness center or yoga studio. Residents also enjoy a dog park, pet wash, speakeasy lounge and coffee bar. Schedule a tour of Terminal 21, near the Mon Wharf Landing, today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-632f-74ce-bbb0-ddf85d6a1995.webp",
      "featured_image_media": {
        "alt_text": "Riverfront with steamboats, industrial buildings, and bridges in the background.",
        "public_id": "01a13d61-632f-74ce-bbb0-ddf85d6a1995",
        "storage_key": "property/6767906449166345/01a13d61-632f-74ce-bbb0-ddf85d6a1995.webp",
        "width": 1600,
        "height": 1286
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mon Wharf Landing | Terminal 21",
      "seo_description": "Apartments near the Mon Wharf Landing in Downtown Pittsburgh. Riverfront trails, river views from select homes and bike storage at Terminal 21. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "residences-near-allegheny-riverfront-park-terminal-21-643",
      "search_query": "residences near allegheny riverfront park allegheny county",
      "category": "Park",
      "h1_title": "Apartments Near Allegheny Riverfront Park",
      "h2_subtitle": "Downtown Pittsburgh lofts near Allegheny Riverfront Park and the Three Rivers Heritage Trail",
      "page_copy": "Terminal 21 offers apartments near Allegheny Riverfront Park, the riverside park along the Allegheny River on the Cultural District side of Downtown Pittsburgh. Its trails link to the Three Rivers Heritage Trail, so you can walk, run or bike along the water and loop back home.\n\nOur loft-style studio, one and two bedroom apartments in Allegheny County feature 11 foot ceilings, oversized windows and kitchens with quartz countertops and stainless steel appliances, with city and river views from select homes. In-home washers and dryers are available. Store and tune up your bike at our bike storage and repair station, then enjoy the 24-hour fitness center, yoga studio, dog park and speakeasy lounge. Schedule a tour of our apartments near Allegheny Riverfront Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-963b-770a-9140-3abe5d3c692c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a city skyline with bridges over a river.",
        "public_id": "01a13d61-963b-770a-9140-3abe5d3c692c",
        "storage_key": "property/6767906449166345/01a13d61-963b-770a-9140-3abe5d3c692c.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Allegheny Riverfront Park | Terminal 21",
      "seo_description": "Apartments near Allegheny Riverfront Park in Allegheny County. Loft-style homes with bike storage and river views from select homes at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartment-living-by-ppg-plaza-terminal-21-downtown-903",
      "search_query": "apartment living by ppg plaza downtown",
      "category": "Park",
      "h1_title": "Apartments Near PPG Place in Downtown Pittsburgh",
      "h2_subtitle": "Loft-style apartments a short walk from PPG Place, Market Square and Downtown's winter ice rink",
      "page_copy": "Terminal 21 offers apartment living a short walk from PPG Place, the glass castle of Downtown Pittsburgh. In winter, the plaza hosts the city's favorite outdoor ice rink and holiday tree, and Market Square's restaurants and events are right next door the rest of the year.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances, with city and river views from select homes. Residents share a speakeasy lounge, coffee bar, game room, co-working lounge and 24-hour fitness center, plus a dog park and pet wash. First Avenue Station is steps away, and with Downtown at your door, you may not need your car much. Schedule a tour of our apartments near PPG Place today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-c52f-7496-b42e-2733d44a4b07.webp",
      "featured_image_media": {
        "alt_text": "Large Christmas tree in front of modern glass buildings, with two people holding an umbrella.",
        "public_id": "01a13d61-c52f-7496-b42e-2733d44a4b07",
        "storage_key": "property/6767906449166345/01a13d61-c52f-7496-b42e-2733d44a4b07.webp",
        "width": 1600,
        "height": 1425
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near PPG Place Downtown | Terminal 21",
      "seo_description": "Apartments near PPG Place and Market Square in Downtown Pittsburgh. Loft-style studios, 1 and 2 bedrooms with a speakeasy lounge at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "terminal-21-rentals-near-mellon-square-pa-71",
      "search_query": "terminal 21 rentals near mellon square pa",
      "category": "Park",
      "h1_title": "Apartment Rentals Near Mellon Square in Pittsburgh",
      "h2_subtitle": "Downtown Pittsburgh lofts a short walk from Mellon Square's gardens, fountains and lunchtime crowds",
      "page_copy": "Terminal 21 offers apartment rentals near Mellon Square, the mid-century plaza on Smithfield Street with fountains, gardens and plenty of seating in the middle of Downtown Pittsburgh. It is a short walk from our home at 615 First Avenue, and an easy place to take lunch outside or meet a friend.\n\nOur loft-style studio, one and two bedroom rentals feature 11 foot ceilings, oversized windows, quartz countertops, stainless steel appliances and a dishwasher, with in-home washers and dryers available. Residents enjoy a co-working lounge, speakeasy lounge, coffee bar, 24-hour fitness center, yoga studio, dog park and pet wash, plus Amazon Hub lockers and a controlled-access building. First Avenue Station is steps away for trips across the city. Schedule a tour of our rentals near Mellon Square today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d61-f6a4-761f-8e7d-421e03c976a7.webp",
      "featured_image_media": {
        "alt_text": "People sitting in a park area with surrounding buildings and trees.",
        "public_id": "01a13d61-f6a4-761f-8e7d-421e03c976a7",
        "storage_key": "property/6767906449166345/01a13d61-f6a4-761f-8e7d-421e03c976a7.webp",
        "width": 1600,
        "height": 1088
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Mellon Square Pittsburgh | Terminal 21",
      "seo_description": "Apartment rentals near Mellon Square in Downtown Pittsburgh. Loft-style studios, 1 and 2 bedrooms with a dog park and fitness center at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "homes-close-to-allegheny-landing-terminal-21-383",
      "search_query": "homes close to allegheny landing pittsburgh",
      "category": "Park",
      "h1_title": "Apartments Near Allegheny Landing in Pittsburgh",
      "h2_subtitle": "Downtown lofts across the river from Allegheny Landing's sculpture park and the North Shore Riverfront Park",
      "page_copy": "Terminal 21 offers Downtown Pittsburgh apartments just across the Allegheny River from Allegheny Landing, the riverside sculpture park on the North Shore. Walk or bike over one of the downtown bridges to reach its public art, river views and trail connections along the North Shore Riverfront Park.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings and oversized windows, with city and river views from select homes. Kitchens include quartz countertops, stainless steel appliances and a dishwasher, and in-home washers and dryers are available. Store your bike in the bike storage and repair station, then enjoy the 24-hour fitness center, yoga studio, dog park and speakeasy lounge. Schedule a tour of our apartments near Allegheny Landing today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d62-26e0-70b3-92dd-7595b1aadad6.webp",
      "featured_image_media": {
        "alt_text": "Waterfront park with walking paths, green spaces, and urban buildings.",
        "public_id": "01a13d62-26e0-70b3-92dd-7595b1aadad6",
        "storage_key": "property/6767906449166345/01a13d62-26e0-70b3-92dd-7595b1aadad6.webp",
        "width": 1600,
        "height": 1072
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Allegheny Landing Pittsburgh | Terminal 21",
      "seo_description": "Apartments near Allegheny Landing and the North Shore in Pittsburgh. Downtown lofts with bike storage and a fitness center at Terminal 21. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "apartments-near-first-avenue-station-terminal-21-94",
      "search_query": "apartments near First Avenue Station Pittsburgh",
      "category": "Transit",
      "h1_title": "Apartments Near First Avenue Station in Pittsburgh",
      "h2_subtitle": "Loft-style apartments steps from First Avenue Station on the T and multiple PRT bus routes",
      "page_copy": "Terminal 21 is steps from First Avenue Station, so catching the T is part of your walk out the door. Light rail connects you to the rest of Downtown, the North Shore and the South Hills, and multiple PRT bus routes run nearby. With a 93 Walk Score, most errands do not require a car at all.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances, with city and river views from select homes. In-home washers and dryers are available, and Amazon Hub lockers keep packages secure while you are out. Residents also enjoy a co-working lounge, speakeasy lounge, 24-hour fitness center, yoga studio, dog park and bike storage and repair station. On-site parking is available if you do drive. Schedule a tour of our apartments near First Avenue Station today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d66-bc28-742a-8ac1-72def3f57f3f.webp",
      "featured_image_media": {
        "alt_text": "Train station platform at dusk with a train arriving.",
        "public_id": "01a13d66-bc28-742a-8ac1-72def3f57f3f",
        "storage_key": "property/6767906449166345/01a13d66-bc28-742a-8ac1-72def3f57f3f.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near First Avenue Station | Terminal 21",
      "seo_description": "Apartments steps from First Avenue Station in Downtown Pittsburgh. Loft-style studios, 1 and 2 bedrooms with a 93 Walk Score at Terminal 21. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "terminal-21-apartments-close-to-steel-plaza-66",
      "search_query": "Terminal 21 apartments close to Steel Plaza Station PA",
      "category": "Transit",
      "h1_title": "Apartments Near Steel Plaza Station in Pittsburgh",
      "h2_subtitle": "Downtown lofts one T stop from Steel Plaza Station and a short walk from Grant Street offices",
      "page_copy": "Terminal 21 offers apartments near Steel Plaza Station, one T stop from First Avenue Station at our front door. Ride one stop or walk a few blocks to Steel Plaza and the Grant Street office corridor, which makes for an easy commute to many Downtown Pittsburgh employers.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances, with city and river views from select homes. In-home washers and dryers are available, and Amazon Hub lockers handle deliveries while you are at work. On days you work from home, use the co-working lounge, work pods or conference room. After hours, enjoy the speakeasy lounge, 24-hour fitness center, yoga studio and dog park. Schedule a tour of our apartments near Steel Plaza Station today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d66-ec16-7312-b99b-e283f145b4c6.webp",
      "featured_image_media": {
        "alt_text": "People waiting on a subway platform.",
        "public_id": "01a13d66-ec16-7312-b99b-e283f145b4c6",
        "storage_key": "property/6767906449166345/01a13d66-ec16-7312-b99b-e283f145b4c6.webp",
        "width": 1600,
        "height": 1071
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Steel Plaza Station | Terminal 21",
      "seo_description": "Apartments near Steel Plaza Station in Downtown Pittsburgh. One T stop away, with loft-style studios, 1 and 2 bedrooms at Terminal 21. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "downtown-pittsburgh-apartments-by-wood-st-station-914",
      "search_query": "Downtown Pittsburgh apartments by Wood St Station",
      "category": "Transit",
      "h1_title": "Downtown Pittsburgh Apartments Near Wood Street Station",
      "h2_subtitle": "Loft-style apartments a short T ride from Wood Street Station and Downtown's shopping and dining",
      "page_copy": "Terminal 21 offers Downtown Pittsburgh apartments a short ride from Wood Street Station. Hop on the T at First Avenue Station, steps from our door, and you are at Wood Street in a couple of stops, close to Market Square, PPG Place and Downtown's shops and restaurants.\n\nOur loft-style studio, one and two bedroom apartments feature 11 foot ceilings, oversized windows, quartz countertops and stainless steel appliances, with city and river views from select homes. In-home washers and dryers are available, and there is a laundry room on every floor. Residents enjoy a speakeasy lounge, coffee bar, game room, co-working lounge, 24-hour fitness center, yoga studio and dog park, all in a controlled-access building with on-site management and maintenance. Schedule a tour of our Downtown Pittsburgh apartments near Wood Street Station today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166345/01a13d67-1cd3-7553-8288-b153ab7e1890.webp",
      "featured_image_media": {
        "alt_text": "Wood Street Station platform with train tracks and signage.",
        "public_id": "01a13d67-1cd3-7553-8288-b153ab7e1890",
        "storage_key": "property/6767906449166345/01a13d67-1cd3-7553-8288-b153ab7e1890.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wood St Station Downtown | Terminal 21",
      "seo_description": "Downtown Pittsburgh apartments near Wood Street Station. Loft-style studios, 1 and 2 bedrooms steps from First Avenue Station at Terminal 21. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166345",
      "source": "custom",
      "page_item_url": "1",
      "search_query": "",
      "category": "",
      "h1_title": "",
      "h2_subtitle": "",
      "page_copy": "",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5082"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976282896"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973433"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K3D22XVS"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveterminal21.fatwin.com/api/websites/resources/1?x=Y3JpbzNMbjJBZkdWeTBMS1lrWXcxVXNxcDE5MnhYVFNXdjVmaFlnU1ZIQ2ZhaGtkWXpWYklYWGxnM0F3YkpKeUExaGEyS2gvRmJDVmlLVFJqRnJRa2c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Stadium House"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55474708127"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw97ojzvo9"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9547b520-43e6-11ef-85e0-db3564e610dd"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547b520-43e6-11ef-85e0-db3564e610dd/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547b520-43e6-11ef-85e0-db3564e610dd/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkIvR2lGeDZ4TDkrT25tdlNnT21EYlE9PSIsInZhbHVlIjoiRTAwbzVxclJKVHRqcWJOck1DZnRSdz09IiwibWFjIjoiODQxOGY0MGZkMWU1ZDdiZTY3ZjRhODI5N2I1YmNjZjM5MzFiZDI2ZWQ3NjZhZTM4YmViMjAzN2ExOWExNGJmNyJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5082",
  "custom_repli_id": "9976282896",
  "custom_realpage_id": "4973433",
  "custom_google_gtm_id": "GTM-K3D22XVS",
  "custom_perq_script_url": "https://liveterminal21.fatwin.com/api/websites/resources/1?x=Y3JpbzNMbjJBZkdWeTBMS1lrWXcxVXNxcDE5MnhYVFNXdjVmaFlnU1ZIQ2ZhaGtkWXpWYklYWGxnM0F3YkpKeUExaGEyS2gvRmJDVmlLVFJqRnJRa2c9PQ2",
  "custom_vibesites_theme": "Stadium House",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "55474708127",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/dqw97ojzvo9",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9547b520-43e6-11ef-85e0-db3564e610dd",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547b520-43e6-11ef-85e0-db3564e610dd/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9547b520-43e6-11ef-85e0-db3564e610dd/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkIvR2lGeDZ4TDkrT25tdlNnT21EYlE9PSIsInZhbHVlIjoiRTAwbzVxclJKVHRqcWJOck1DZnRSdz09IiwibWFjIjoiODQxOGY0MGZkMWU1ZDdiZTY3ZjRhODI5N2I1YmNjZjM5MzFiZDI2ZWQ3NjZhZTM4YmViMjAzN2ExOWExNGJmNyJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "32d4db33-8957-4292-aeb6-4f379fcaf57d",
  "custom_audioeye_site_hash": "9e5014c1c38a3bb78e79eb616fc0fabb"
};

export const generatedAt = '2026-10-22T20:05:02.820Z';
